svg4everybody();

// eslint-disable-next-line no-unused-vars
let videoListOriginal = {
	key: '/7+Ul69pdtloM/HZ/NiP71Ty0dz184WqvcwzdA==',
	main: 'http://vod.spec.rbc.ru/galaxys8.rbc.ru/video/main-video.mp4',
	content: {
		1: {
			1: 'http://vod.spec.rbc.ru/galaxys8.rbc.ru/videocontent/hero-1-video-1.mp4',
		},
		2: {
			1: 'http://vod.spec.rbc.ru/galaxys8.rbc.ru/videocontent/hero-2-video-1.mp4',
		},
		3: {
			1: 'http://vod.spec.rbc.ru/galaxys8.rbc.ru/videocontent/hero-3-video-1.mp4',
			2: 'http://vod.spec.rbc.ru/galaxys8.rbc.ru/videocontent/hero-3-video-2.mp4',
		},
		4: {
			1: 'http://vod.spec.rbc.ru/galaxys8.rbc.ru/videocontent/hero-4-video-1.mp4',
		},
		5: {
			1: 'http://vod.spec.rbc.ru/galaxys8.rbc.ru/videocontent/hero-5-video-1.mp4',
			2: 'http://vod.spec.rbc.ru/galaxys8.rbc.ru/videocontent/hero-5-video-2.mp4',
		},
		6: {
			1: 'http://vod.spec.rbc.ru/galaxys8.rbc.ru/videocontent/hero-6-video-1.mp4',
		},
		8: {
			1: 'http://vod.spec.rbc.ru/galaxys8.rbc.ru/videocontent/hero-8-video-1.mp4',
			2: 'http://vod.spec.rbc.ru/galaxys8.rbc.ru/videocontent/hero-8-video-2.mp4',
		},
		9: {
			1: 'http://vod.spec.rbc.ru/galaxys8.rbc.ru/videocontent/hero-9-video-1.mp4',
		},
		10: {
			1: 'http://vod.spec.rbc.ru/galaxys8.rbc.ru/videocontent/hero-10-video-1.mp4',
			2: 'http://vod.spec.rbc.ru/galaxys8.rbc.ru/videocontent/hero-10-video-2.mp4',
		},
		11: {
			1: 'http://vod.spec.rbc.ru/galaxys8.rbc.ru/videocontent/hero-11-video-1.mp4',
			2: 'http://vod.spec.rbc.ru/galaxys8.rbc.ru/videocontent/hero-11-video-2.mp4',
		},
	},
	1: 'http://vod.spec.rbc.ru/galaxys8.rbc.ru/video/1/hero-video-1-720.mp4',
	2: 'http://vod.spec.rbc.ru/galaxys8.rbc.ru/video/2/hero-video-2-720.mp4',
	3: 'http://vod.spec.rbc.ru/galaxys8.rbc.ru/video/3/hero-video-3-720.mp4',
	4: 'http://vod.spec.rbc.ru/galaxys8.rbc.ru/video/4/hero-video-4-720.mp4',
	5: 'http://vod.spec.rbc.ru/galaxys8.rbc.ru/video/5/hero-video-5-720.mp4',
	6: 'http://vod.spec.rbc.ru/galaxys8.rbc.ru/video/6/hero-video-6-720.mp4',
	7: 'http://vod.spec.rbc.ru/galaxys8.rbc.ru/video/7/hero-video-7-720.mp4',
	8: 'http://vod.spec.rbc.ru/galaxys8.rbc.ru/video/8/hero-video-8-720.mp4',
	9: 'http://vod.spec.rbc.ru/galaxys8.rbc.ru/video/9/hero-video-9-720.mp4',
	10: 'http://vod.spec.rbc.ru/galaxys8.rbc.ru/video/10/hero-video-10-720.mp4',
	11: 'http://vod.spec.rbc.ru/galaxys8.rbc.ru/video/11/hero-video-11-720.mp4',
};

// eslint-disable-next-line no-unused-vars
let videoListJw = {
	key: 'kYJCtSColr3yYPWg4d7N8iqzenJWfyVR/yN8jvszUArcUeiBNoO9WotrnlQ=',
	main: 'https://content.jwplatform.com/manifests/pLZbiwkt.m3u8',
	content: {
		1: {
			1: 'https://content.jwplatform.com/manifests/uVBHjMKt.m3u8',
		},
		2: {
			1: 'https://content.jwplatform.com/manifests/KrnP5xse.m3u8',
		},
		3: {
			1: 'https://content.jwplatform.com/manifests/tL6MSVCQ.m3u8',
			2: 'https://content.jwplatform.com/manifests/b9AvLRsA.m3u8',
		},
		4: {
			1: 'https://content.jwplatform.com/manifests/3DSreF5U.m3u8',
		},
		5: {
			1: 'https://content.jwplatform.com/manifests/TTg2Ly0v.m3u8',
			2: 'https://content.jwplatform.com/manifests/7Bivhtr4.m3u8',
		},
		6: {
			1: 'https://content.jwplatform.com/manifests/1hcdr9mQ.m3u8',
		},
		8: {
			1: 'https://content.jwplatform.com/manifests/tgQNcrxf.m3u8',
			2: 'https://content.jwplatform.com/manifests/hhfkLj1s.m3u8',
		},
		9: {
			1: 'https://content.jwplatform.com/manifests/klB3HUmM.m3u8',
		},
		10: {
			1: 'https://content.jwplatform.com/manifests/t8FSJr5N.m3u8',
			2: 'https://content.jwplatform.com/manifests/j5NXrKTO.m3u8',
		},
		11: {
			1: 'https://content.jwplatform.com/manifests/5FwJHKvO.m3u8',
			2: 'https://content.jwplatform.com/manifests/PmHnHRxN.m3u8',
		},
	},
	1: 'https://content.jwplatform.com/manifests/JPC3tRVz.m3u8',
	2: 'https://content.jwplatform.com/manifests/y2bgRk4l.m3u8',
	3: 'https://content.jwplatform.com/manifests/HJBxRjhy.m3u8',
	4: 'https://content.jwplatform.com/manifests/rxVAxDgK.m3u8',
	5: 'https://content.jwplatform.com/manifests/zGIBBoQb.m3u8',
	6: 'https://content.jwplatform.com/manifests/wb9kr9KA.m3u8',
	7: 'https://content.jwplatform.com/manifests/xPk2SH3f.m3u8',
	8: 'https://content.jwplatform.com/manifests/wx7zfFHs.m3u8',
	9: 'https://content.jwplatform.com/manifests/RfwkwyPi.m3u8',
	10: 'https://content.jwplatform.com/manifests/sJHnwWuv.m3u8',
	11: 'https://content.jwplatform.com/manifests/w66XsOZK.m3u8',
};

let videoList = videoListJw;

jwplayer.key = videoList.key;

(() => {
	let iterate = (items, callback) => {
		items.forEach((item) => {
			let key;
			let value;

			if (typeof item === 'string') {
				key = item;
				value = item;
			} else {
				key = item[0];
				value = item[1];
			}

			callback(key, value);
		});
	};

	let check = (category, items) => {
		iterate(items, (key, value) => {
			if (bowser[key]) {
				$(document.documentElement).addClass(`is-${category}-${value}`);
			}
		});
	};

	check(
		'engine',
		[
			'webkit',
			'blink',
			'gecko',
			['msie', 'ie'],
			['msedge', 'edge'],
		]
	);

	check(
		'device',
		[
			'mobile',
			'tablet',
		]
	);

	check(
		'browser',
		[
			'chrome',
			'firefox',
			['msie', 'ie'],
			['msedge', 'edge'],
			'safari',
			'android',
			'ios',
			'opera',
			['samsungBrowser', 'samsung'],
			'phantom',
			'blackberry',
			'webos',
			'silk',
			'bada',
			'tizen',
			'seamonkey',
			'sailfish',
			'ucbrowser',
			'qupzilla',
			'vivaldi',
			'sleipnir',
			'kMeleon',
		]
	);

	check(
		'os',
		[
			'mac',
			'windows',
			'windowsphone',
			'linux',
			'chromeos',
			'android',
			'ios',
			'iphone',
			'ipad',
			'ipod',
			'blackberry',
			'firefoxos',
			'webos',
			'bada',
			'tizen',
			'sailfish',
		]
	);

	if ('ontouchstart' in window || navigator.maxTouchPoints) {
		$(document.documentElement).addClass('is-device-touch');
	} else {
		$(document.documentElement).addClass('is-device-mouse');
	}

	if (bowser.msie) {
		if (parseInt(bowser.version, 10) === 10) {
			$(document.documentElement).addClass('is-browser-ie-10');
		}
	}
})();

function queryParse(type) {
	let query = location.search.slice(1).split('&')
		.filter((x) => x);

	let queryObj = {
	};

	for (let i = 0; i < query.length; i += 1) {
		let arg = query[i].split('=');
		let key = arg[0];
		let value = arg[1];

		if (value === undefined) {
			value = true;
		}

		query[i] = {
			key,
			value,
		};

		queryObj[key] = value;
	}

	if (type === 'object') {
		return queryObj;
	}

	return query;
}

function queryStringify(query) {
	return query
		.filter((arg) => arg.value !== null && arg.value !== false && arg.value !== undefined)
		.map((arg) => {
			if (arg.value === true) {
				return arg.key;
			}

			return `${arg.key}=${arg.value}`;
		})
		.join('&');
}

// eslint-disable-next-line no-unused-vars
function queryPush(args, pathname) {
	let query = queryParse();

	Object.keys(args).forEach((key) => {
		let value = args[key];

		for (let i = 0; i < query.length; i += 1) {
			let arg = query[i];

			if (arg.key === key) {
				arg.value = value;

				return;
			}
		}

		query.push({
			key,
			value,
		});
	});

	query = queryStringify(query);

	if (query) {
		query = `?${query}`;
	}

	history.pushState(null, '', (pathname || location.pathname) + query + location.hash);
}

// eslint-disable-next-line no-unused-vars
function checkMail(email) {
	// eslint-disable-next-line no-useless-escape
	let filter = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

	return filter.test(email);
}

function getCookie(name) {
	let start = document.cookie.indexOf(`${name}=`);
	let len = start + name.length + 1;

	if (!start && name !== document.cookie.substring(0, name.length)) {
		return null;
	}

	if (start === -1) {
		return null;
	}

	let end = document.cookie.indexOf(';', len);

	if (end === -1) {
		end = document.cookie.length;
	}

	return unescape(document.cookie.substring(len, end));
}

// eslint-disable-next-line no-unused-vars
function setCookie(name, value, expires, path, domain, secure) {
	let today = new Date();

	today.setTime(today.getTime());

	if (expires) {
		expires = expires * 1000 * 60 * 60 * 24;
	}

	let expiresDate = new Date(today.getTime() + expires);

	document.cookie = `${name}=${escape(value)}${expires ? `;expires=${expiresDate.toGMTString()}` : ''}${path ? `;path=${path}` : ''}${domain ? `;domain=${domain}` : ''}${secure ? ';secure' : ''}`;
}

// eslint-disable-next-line no-unused-vars
function deleteCookie(name, path, domain) {
	if (getCookie(name)) {
		document.cookie = `${name}=${path ? `;path=${path}` : ''}${domain ? `;domain=${domain}` : ''};expires=Thu, 01-Jan-1970 00:00:01 GMT`;
	}
}

/* global pagesData */
/* eslint-disable object-curly-newline, no-underscore-dangle */

let Share = {
	_metaElements() {
		return {
			description: document.querySelector('meta[name="description"]') || {},
			ogType: document.querySelector('meta[name="og:type"]') || {},
			ogUrl: document.querySelector('meta[name="og:url"]') || {},
			ogTitle: document.querySelector('meta[name="og:title"]') || {},
			ogDescription: document.querySelector('meta[name="og:description"]') || {},
			ogImage: document.querySelector('meta[name="og:image"]') || {},
			ogLocale: document.querySelector('meta[name="og:locale"]') || {},
			twitterCard: document.querySelector('meta[name="twitter:card"]') || {},
			twitterTitle: document.querySelector('meta[name="twitter:title"]') || {},
			twitterDescription: document.querySelector('meta[name="twitter:description"]') || {},
			imageSrc: document.querySelector('link[rel="image_src"]') || {},
		};
	},
	_metaData() {
		let metaElements = this._metaElements();

		return {
			url: location.href,
			title: document.title,
			description: metaElements.description.content || '',
			ogType: metaElements.ogType.content || '',
			ogUrl: metaElements.ogUrl.content || '',
			ogTitle: metaElements.ogTitle.content || '',
			ogDescription: metaElements.ogDescription.content || '',
			ogImage: metaElements.ogImage.content || '',
			ogLocale: metaElements.ogLocale.content || '',
			twitterCard: metaElements.twitterCard.content || '',
			twitterTitle: metaElements.twitterTitle.content || '',
			twitterDescription: metaElements.twitterDescription.content || '',
			imageSrc: metaElements.imageSrc.href || '',
		};
	},
	_metaUpdate(newMetaData) {
		let metaElements = this._metaElements();
		let metaData = this._metaData();

		document.title = newMetaData.title || metaData.title;
		metaElements.description.content = newMetaData.description || metaData.description;
		metaElements.ogType.content = newMetaData.ogType || metaData.ogType;
		metaElements.ogUrl.content = newMetaData.ogUrl || metaData.ogUrl;
		metaElements.ogTitle.content = newMetaData.ogTitle || metaData.ogTitle;
		metaElements.ogDescription.content = newMetaData.ogDescription || metaData.ogDescription;
		metaElements.ogImage.content = newMetaData.ogImage || metaData.ogImage;
		metaElements.ogLocale.content = newMetaData.ogLocale || metaData.ogLocale;
		metaElements.twitterCard.content = newMetaData.twitterCard || metaData.twitterCard;
		metaElements.twitterTitle.content = newMetaData.twitterTitle || metaData.twitterTitle;
		metaElements.twitterDescription.content = newMetaData.twitterDescription || metaData.twitterDescription;
		metaElements.imageSrc.href = newMetaData.imageSrc || metaData.imageSrc;
	},
	_metaUpdateByPageData(pageData) {
		pageData = pageData || {};

		this._metaUpdate({
			title: pageData.title,
			description: pageData.description,
			ogUrl: pageData.url,
			ogTitle: pageData.title,
			ogDescription: pageData.description,
			ogImage: pageData.image,
			twitterTitle: pageData.twitterTitle,
			twitterDescription: pageData.twitterDescription,
			imageSrc: pageData.image,
		});
	},
	_absUrl(url) {
		if (url.match(/^http[s]?:\/\//)) {
			return url;
		}

		if (url.match(new RegExp(`^${location.host}`))) {
			return `${location.protocol}//${url}`;
		}

		if (url.match(/^\/\//)) {
			return location.protocol + url;
		}

		return `${location.protocol}//${location.host}${url}`;
	},
	_window(url) {
		return window.open(url, 'Поделиться', 'width=640,height=480,location=no,toolbar=no,menubar=no');
	},
	facebook(url, title, description, picture) {
		let meta = this._metaData();

		url = encodeURIComponent(this._absUrl(url || meta.ogUrl || meta.url));
		title = encodeURIComponent(title || meta.ogTitle || meta.title);
		description = encodeURIComponent(description || meta.ogDescription || meta.description);
		picture = encodeURIComponent(this._absUrl(picture || meta.ogImage));

		return this._window(`https://facebook.com/sharer/sharer.php?u=${url}&title=${title}&description=${description}&picture=${picture}`);
	},
	twitter(url, text) {
		let meta = this._metaData();

		url = encodeURIComponent(this._absUrl(url || meta.ogUrl || meta.url));
		text = encodeURIComponent(text || meta.twitterTitle || meta.ogTitle || meta.title);

		return this._window(`http://twitter.com/share?url=${url}&text=${text}`);
	},
	googlePlus(url) {
		let meta = this._metaData();

		url = encodeURIComponent(this._absUrl(url || meta.ogUrl || meta.url));

		return this._window(`https://plus.google.com/share?url=${url}`);
	},
	vk(url, title, description, image) {
		let meta = this._metaData();

		url = encodeURIComponent(this._absUrl(url || meta.ogUrl || meta.url));
		title = encodeURIComponent(title || meta.ogTitle || meta.title);
		description = encodeURIComponent(description || meta.ogDescription || meta.description);
		image = encodeURIComponent(this._absUrl(image || meta.imageSrc || meta.ogImage));

		if ($(document.documentElement).hasClass('is-device-mobile')) {
			description = '';
		}

		return this._window(`https://vk.com/share.php?url=${url}&title=${title}&description=${description}&image=${image}`);
	},
	page(name, socialName) {
		let pageData = pagesData[name];
		let url = pageData.url;
		let title = pageData.title;
		let description = pageData.description;
		let twitterTitle = pageData.twitterTitle;
		let twitterDescription = pageData.twitterDescription; // eslint-disable-line
		let image = pageData.image;

		switch (socialName) {
			case 'fb':
			case 'facebook':
				Share.facebook(url, title, description, image);
				break;
			case 'tw':
			case 'twitter':
				Share.twitter(url, twitterTitle);
				break;
			case 'g+':
			case 'google+':
			case 'gp':
			case 'googlePlus':
			case 'google plus':
				Share.googlePlus(url);
				break;
			case 'vk':
			case 'vkontakte':
				Share.vk(url, title, description, image);
				break;
			// no default
		}
	},
};

/* global Share */

// eslint-disable-next-line no-unused-vars
let pagesData = {
	'map': {
		url: '',
		title: 'От Владивостока до Калининграда – Россия без границ',
		description: 'В совместном спецпроекте Samsung и РБК одиннадцать героев со всей России хотят доказать всем, что границы существуют только в наших головах.',
		image: `${location.protocol}//${location.host}/images/share-main.png`,
	},
	'hero-1': {
		url: '',
		title: 'Екатерина Седых в проекте «Россия без границ»',
		description: 'В совместном спецпроекте Samsung и РБК одиннадцать героев со всей России хотят доказать всем, что границы существуют только в наших головах.',
		image: `${location.protocol}//${location.host}/images/share-hero-1.png`,
	},
	'hero-2': {
		url: '',
		title: 'Патрисио Лемос в проекте «Россия без границ»',
		description: 'В совместном спецпроекте Samsung и РБК одиннадцать героев со всей России хотят доказать всем, что границы существуют только в наших головах.',
		image: `${location.protocol}//${location.host}/images/share-hero-2.png`,
	},
	'hero-3': {
		url: '',
		title: 'Сергей Перевозников в проекте «Россия без границ»',
		description: 'В совместном спецпроекте Samsung и РБК одиннадцать героев со всей России хотят доказать всем, что границы существуют только в наших головах.',
		image: `${location.protocol}//${location.host}/images/share-hero-3.png`,
	},
	'hero-4': {
		url: '',
		title: 'Владимир Невейкин в проекте «Россия без границ»',
		description: 'В совместном спецпроекте Samsung и РБК одиннадцать героев со всей России хотят доказать всем, что границы существуют только в наших головах.',
		image: `${location.protocol}//${location.host}/images/share-hero-4.png`,
	},
	'hero-5': {
		url: '',
		title: 'Степан Тропин в проекте «Россия без границ»',
		description: 'В совместном спецпроекте Samsung и РБК одиннадцать героев со всей России хотят доказать всем, что границы существуют только в наших головах.',
		image: `${location.protocol}//${location.host}/images/share-hero-5.png`,
	},
	'hero-6': {
		url: '',
		title: 'Нелли Лабунская в проекте «Россия без границ»',
		description: 'В совместном спецпроекте Samsung и РБК одиннадцать героев со всей России хотят доказать всем, что границы существуют только в наших головах.',
		image: `${location.protocol}//${location.host}/images/share-hero-6.png`,
	},
	'hero-7': {
		url: '',
		title: 'Александра Воскресенская в проекте «Россия без границ»',
		description: 'В совместном спецпроекте Samsung и РБК одиннадцать героев со всей России хотят доказать всем, что границы существуют только в наших головах.',
		image: `${location.protocol}//${location.host}/images/share-hero-7.png`,
	},
	'hero-8': {
		url: '',
		title: 'Андрей Светов в проекте «Россия без границ»',
		description: 'В совместном спецпроекте Samsung и РБК одиннадцать героев со всей России хотят доказать всем, что границы существуют только в наших головах.',
		image: `${location.protocol}//${location.host}/images/share-hero-8.png`,
	},
	'hero-9': {
		url: '',
		title: 'Татьяна Неклюдова в проекте «Россия без границ»',
		description: 'В совместном спецпроекте Samsung и РБК одиннадцать героев со всей России хотят доказать всем, что границы существуют только в наших головах.',
		image: `${location.protocol}//${location.host}/images/share-hero-9.png`,
	},
	'hero-10': {
		url: '',
		title: 'Алексей Глебов в проекте «Россия без границ»',
		description: 'В совместном спецпроекте Samsung и РБК одиннадцать героев со всей России хотят доказать всем, что границы существуют только в наших головах.',
		image: `${location.protocol}//${location.host}/images/share-hero-10.png`,
	},
	'hero-11': {
		url: '',
		title: 'Никита Тамаров в проекте «Россия без границ»',
		description: 'В совместном спецпроекте Samsung и РБК одиннадцать героев со всей России хотят доказать всем, что границы существуют только в наших головах.',
		image: `${location.protocol}//${location.host}/images/share-hero-11.png`,
	},
};

$('[data-social]').on('click', (e) => {
	let $this = $(e.currentTarget);
	let url = $this.data('url');
	let title = $this.data('title');
	let description = $this.data('description');
	let image = $this.data('image');

	e.preventDefault();
	$this.trigger('blur');

	switch ($this.data('social')) {
		case 'facebook':
			Share.facebook(url, title, description, image);
			break;
		case 'vkontakte':
			Share.vk(url, title, description, image);
			break;
		case 'twitter':
			Share.twitter(url, title);
			break;
		// no default
	}
});

/* global yaCounter45115419 */

// eslint-disable-next-line no-unused-vars
let changePathCounter = (path) => {
	if (!window.directEnter) {
		ga('set', 'page', `/${path}`);
		ga('send', 'pageview', `/${path}`);

		ga('rbcspec.set', 'page', `/${path}`);
		ga('rbcspec.send', 'pageview', `/${path}`);
		yaCounter45115419.hit(`http://galaxys8.rbc.ru/${path}`);
	}

	window.directEnter = false;
};

setTimeout(() => {
	ga('rbcspec.send', 'event', 'page', 'spent_on_page_15_sec');
	ga('send', 'event', 'page', 'spent_on_page_15_sec');
}, 15000);

$('.top-menu__item').on('click', (event) => {
	let $this = $(event.currentTarget);
	let thisName = $this.data('name');

	ga('send', 'event', 'menu', thisName);
});

$('.top-menu__item[data-link="top-menu-galaxy"]').on('click', () => {
	ga('send', 'event', 'client link', 'from menu');
});

$('.card').on('click', () => {
	ga('send', 'event', 'client link', 'phone image footer');
});

$('.phone').on('click', () => {
	ga('send', 'event', 'client link', 'logo footer');
});

$('.vendor').on('click', () => {
	ga('send', 'event', 'client link', 'logo header');
});

$('.sound').on('click', (event) => {
	let $this = $(event.currentTarget);

	setTimeout(() => {
		if ($this.hasClass('is-off')) {
			ga('send', 'event', 'sound', 'off');
		} else {
			ga('send', 'event', 'sound', 'on');
		}
	}, 50);
});

$('.screen__social .social__item').on('click', (event) => {
	let $this = $(event.currentTarget);
	let thisName = $this.data('share');

	ga('send', 'event', 'share', 'project share footer', thisName);
});

$('.form__social .social__item').on('click', (event) => {
	let $this = $(event.currentTarget);
	let thisName = $this.data('share');

	ga('send', 'event', 'share', 'competition share', thisName);
});

$('.competition-gallery__more').on('click', () => {
	ga('send', 'event', 'competition', 'show more');
});

$('.screen-info a[data-lightbox]').on('click', (e) => {
	let $this = $(e.currentTarget);
	let $screen = $this.closest('.screen');
	let $images = $screen.find('a[data-lightbox] img');
	let $image = $this.find('img');
	let name = $screen.data('name');
	let num = $images.index($image) + 1;

	ga('send', 'event', 'hero', 'inner photo', `${name} ${num}`);
});

/* eslint-disable no-underscore-dangle,no-use-before-define,max-len */
/* global checkAudio, changePathCounter, queryParse, queryPush, Share, pagesData, lightbox */

// Global Variables

const $window = $(window);
const $html = $(document.documentElement);
const $body = $(document.body);
const $soundButton = $('.sound');
const $screen = $('.screen');
const $parallax = $('.parallax');

let simpleSound;

// Global mobile variables

const $mobilePopupButton = $('.hamburger');
const $mobilePopup = $('.hamburger__popup');
const $mobileMenu = $mobilePopup.find('.top-menu');
const $mobileSocial = $mobilePopup.find('.social');
const $mobileClose = $mobilePopup.find('.button-close');

// eslint-disable-next-line no-unused-vars
let clearoldphoto = false;

window.canGoToMap = true;
window.canGoToAbout = true;

let cloudsTimeline;

function animateClouds() {
	$parallax.removeClass('is-hidden');

	for (let i = 1; i <= 5; i++) {
		TweenMax.set($parallax.find(`.parallax__item--0${i}`), {
			x: 0,
			y: 0,
			scale: 1,
			autoAlpha: 1,
			force3D: true,
		});
	}

	let cloudTime = 35;

	if (cloudsTimeline) {
		cloudsTimeline.kill();
		cloudsTimeline = null;
	}

	cloudsTimeline = new TimelineMax({
		repeat: -1,
		yoyo: true,
		ease: Linear.easeNone,
	});

	cloudsTimeline
		.to($parallax.children().eq(0), cloudTime, {
			x: 150,
			y: 10,
			force3D: true,
		}, 'start')
		.to($parallax.children().eq(1), cloudTime, {
			x: 150,
			y: 100,
			force3D: true,
		}, 'start')
		.to($parallax.children().eq(2), cloudTime, {
			x: 150,
			y: 100,
			force3D: true,
		}, 'start')
		.to($parallax.children().slice(3), cloudTime, {
			x: 150,
			force3D: true,
		}, 'start');
}

// Global animation popup

let mobileAnimObg = {
	mobileShowPopup() {
		let mobileShowPopupTimeline = new TimelineMax({
			onStart() {
				$mobilePopup.removeClass('is-hidden');
			},
			onComplete() {
				$mobileClose.off('click');
				$mobileClose.on('click', () => {
					mobileAnimObg.mobileHidePopup();
				});
			},
		});

		mobileShowPopupTimeline
			.to($mobilePopup, 1, {
				top: '0%',
			})
			.from($mobileMenu, 0.5, {
				top: -300,
				clearProps: 'all',
			})
			.from($mobileSocial, 0.3, {
				y: 200,
				autoAlpha: 0,
				clearProps: 'all',
			})
			.from($mobileClose, 0.4, {
				autoAlpha: 0,
				rotation: '540',
				ease: Linear.easeNone,
				clearProps: 'all',
			}, '-=0.2');
	},
	mobileHidePopup() {
		let mobileHidePopupTimeline = new TimelineMax({
			onStart() {

			},
			onComplete() {
				[$mobileClose, $mobileSocial, $mobileMenu].forEach((e) => {
					e.removeAttr('style');
				});

				$mobilePopup.addClass('is-hidden');
				mobileHidePopupTimeline.seek(0).kill();
			},
		});

		mobileHidePopupTimeline
			.to($mobileClose, 0.2, {
				autoAlpha: 0,
				rotation: 540,
				ease: Linear.easeNone,
			})
			.to($mobileSocial, 0.3, {
				y: 200,
				autoAlpha: 0,
			})
			.to($mobileMenu, 0, {
				top: -300,
				autoAlpha: 0,
			})
			.to($mobilePopup, 1, {
				y: '-100%',
				clearProps: 'all',
			});
	},
};

$mobilePopupButton.on('click', () => {
	mobileAnimObg.mobileShowPopup();
});

if ($html.outerWidth() <= 1024) {
	$('.top-menu--mobile')
		.find('.top-menu__item')
		.eq(0)
		.attr('href', '/');
}

// Audio init function

const audioInit = () => {
	if ($html.outerWidth() > 1024) {
		simpleSound = jwplayer($('.audio__inner').attr('id', 'simple-audio').get(0)).setup({
			file: '/audio/sound.mp3',
			width: '0',
			height: '0',
			stretching: 'fill',
			autostart: true,
			controls: false,
			mute: false,
			repeat: true,
		});

		simpleSound.setVolume(100);

		$soundButton.on('click', (event) => {
			let $this = $(event.currentTarget);

			if (!$this.hasClass('is-off')) {
				$soundButton.addClass('is-off');
				if (simpleSound) {
					TweenMax.to({
						volume: simpleSound.getVolume(),
					}, 1, {
						volume: 0,
						ease: Linear.easeNone,
						onUpdate() {
							simpleSound.setVolume(this.target.volume);
						},
					});
				}
			} else {
				$soundButton.removeClass('is-off');
				if (simpleSound) {
					TweenMax.to({
						volume: simpleSound.getVolume(),
					}, 1, {
						volume: 100,
						ease: Linear.easeNone,
						onUpdate() {
							simpleSound.setVolume(this.target.volume);
						},
					});
				}
			}
		});

		$window.on('blur', () => {
			if (simpleSound) {
				TweenMax.to({
					volume: simpleSound.getVolume(),
				}, 1.2, {
					volume: 0,
					ease: Linear.easeNone,
					onUpdate: function onUpdate() {
						simpleSound.setVolume(this.target.volume);
					},
				});
			}
		});

		$window.on('focus', () => {
			if ($soundButton.hasClass('is-off')) {
				if (simpleSound) {
					TweenMax.to({
						volume: simpleSound.getVolume(),
					}, 1.2, {
						volume: 0,
						ease: Linear.easeNone,
						onUpdate: function onUpdate() {
							simpleSound.setVolume(this.target.volume);
						},
					});
				}
			} else if (simpleSound) {
				TweenMax.to({
					volume: simpleSound.getVolume(),
				}, 1.2, {
					volume: 100,
					ease: Linear.easeNone,
					onUpdate: function onUpdate() {
						simpleSound.setVolume(this.target.volume);
					},
				});
			}
		});
	}
};

if ($(document.documentElement).hasClass('page-index')) {
	// Variables

	let $screenAbout = $('.screen--about');
	let $screenVideo = $('.screen-video');
	let $screenMain = $('.screen-main');
	let $screenMap = $('.screen-map');
	let $screenHero = $('.screen-hero');
	let $screenInfo = $('.screen-info');
	let $skipButton = $screenVideo.find('.button-skip');
	let introVideo;
	let $mobileSlider = $('.mobile-slider');

	window.directEnter = false;

	// Main page vars

	let $mainScreenBg = $('.screen--02__bg');
	let $mainPageLogo = $('.screen--02__logo');
	let $mainPageProject = $('.screen--02__project');
	let $mainPageVendor = $('.screen--02__vendor');
	let $mainPagePhone = $('.screen--02__phone');
	let $mainPageContentBg = $('.screen--02__content__bg');
	let $mainPageContentTitle = $('.screen--02__content__title');
	let $mainPageContentDescription = $('.screen--02__content__description');
	let $mainPageContentButton = $('.screen--02__content__bg__button');
	let $mainPageTopMenu = $('.screen--02__top-menu');
	let $mainPageSocial = $('.screen--02__social');
	let $mainPageSound = $('.screen--02__sound');
	let showMainTimeline;
	let hideMainTimeline;

	// Map page vars

	let $mapPageFade = $('.screen--03__fade');
	let $mapPageCard = $('.screen--03__card');
	let $mapPageTitle = $('.screen--03__content__title');
	let $mapPageDescription = $('.screen--03__content__description');
	let $mapPageFinger = $('.screen--03__button-finger');
	let $mapPageBg = $('.screen--03__bg');
	let $mapPageRoute = $('.route');
	let $mapPageRouteBg = $('.route__bg');
	let $mapPageRouteItems = $('.route__item');
	let showMapTimeline;
	let hideMapTimeline;

	// Hero page vars

	let $heroPageContent = $('.screen-hero__content');
	let $heroPageContentTitle = $('.screen-hero__content__title');
	let $heroPageContentDescription = $('.screen-hero__content__description');
	let $heroPageContentText = $('.screen-hero__content__text');
	let $heroPageContentCity = $('.screen-hero__content__city');
	let $heroPageCoordinates = $('.coordinates');
	let $heroPageBg = $('.screen-hero__bg');
	let $heroPageFade = $('.screen-hero__fade');
	let $heroPageBgMap = $('.screen-hero__bg-map');
	let $heroBigPhone = $('.big-phone');
	let $heroBigPhoneButton = $('.big-phone__button');
	let $heroMiniMap = $('.mini-map');
	let $heroPageCard = $screenHero.find('.card');
	let $nextButton = $('.button-next');
	let $prevButton = $('.button-prev');
	let nextHeroTimeline;
	let showHeroTimeline;
	let hideHeroTimeline;

	// Info page bg

	let $screenPageInfoBg = $('.screen-info__bg');
	let $infoPageBgMap = $('.screen-info__bg-map');
	let $screenInfoContentWrap = $('.screen-info__content__wrap');
	let showInfoTimeline;

	// Mobile

	let $mobileSliderItemButton = $('.mobile-slider__content__item__button');
	let $sliderItems = $('.mobile-slider__content__item');
	let $sliderDots = $('.mobile-slider__nav__item');
	let mobileHeroSliderTimeline;
	let mobileHideHeroTimeline;
	let mobileShowHeroTimeline;
	let mobileShowInfoTimeline;

	let titlesTimeline;

	// eslint-disable-next-line no-inner-declarations
	function updatePointer() {
		let image = {
			width: 1680,
			height: 850,
		};
		let target = {
			x: 1050,
			y: 140,
		};

		let $pointer = $heroBigPhone;

		let windowWidth = $(window).width();
		let windowHeight = $(window).height();

		// Get largest dimension increase

		let xScale = windowWidth / image.width;
		let yScale = windowHeight / image.height;
		let scale;
		let yOffset = 0;
		let xOffset = 0;

		if (xScale > yScale) {
			// The image fits perfectly in x axis, stretched in y
			scale = xScale;
			yOffset = (windowHeight - image.height * scale) / 2;
		} else {
			// The image fits perfectly in y axis, stretched in x
			scale = yScale;
			xOffset = (windowWidth - image.width * scale) / 2;
		}

		$pointer.css('top', target.y * scale + yOffset);
		$pointer.css('left', target.x * scale + xOffset);
	}

	let animObj = {
		aboutShow() {
			TweenMax.set($screenAbout.find('.screen--about__content'), {
				autoAlpha: 1,
			});

			$screenAbout.removeClass('is-hidden');
			$screenAbout.siblings('.screen-hero, .screen-info').addClass('is-hidden');

			const $aboutContent = $('.screen--about__content');

			let changeTitles = _.once(() => {
				titlesTimeline.remove(titlesTimeline.getChildren());

				titlesTimeline.fromTo($aboutContent, $aboutContent.outerHeight() / 100, {
					y: 0,
					ease: Linear.easeNone,
					force3D: true,
				}, {
					y: -$aboutContent.outerHeight() + $html.outerHeight() - 150,
					ease: Linear.easeNone,
					force3D: true,
				});
			});

			if (!window.aboutInitialized) {
				if (titlesTimeline) {
					titlesTimeline.kill();
					titlesTimeline = null;
				}

				titlesTimeline = new TimelineMax({
					delay: 2,
				});

				let titlesTween = TweenMax.fromTo($aboutContent, ($aboutContent.outerHeight() + $html.outerHeight()) / 100, {
					y: $html.outerHeight() / 2 - 110,
					ease: Linear.easeNone,
					force3D: true,
				}, {
					y: -$aboutContent.outerHeight() + $html.outerHeight() / 2,
					ease: Linear.easeNone,
					force3D: true,
				});

				titlesTimeline.add(titlesTween);
			} else if (titlesTimeline) {
				clearTimeout(window.titlesStartTimeoutId);
				window.titlesStartTimeoutId = setTimeout(() => {
					titlesTimeline.seek(0);
					titlesTimeline.play();
				}, 2000);
			}

			if ($html.outerWidth() <= 1024) {
				if (!window.aboutInitialized) {
					$window.swipe({
						swipeStatus(event, phase, dir) {
							clearTimeout(window.titlesStartTimeoutId);
							titlesTimeline.pause();

							let progress = titlesTimeline.progress();
							let progressStep = 0.0065;
							let newTime;

							if (progress >= 0.2) {
								changeTitles();
							}

							if (dir === 'down') {
								progressStep = -progressStep;
							}

							newTime = progress + progressStep;
							if (newTime < 0) {
								newTime = 0;
							}

							newTime = progress + progressStep;
							if (newTime < 0) {
								newTime = 0;
							}
							titlesTimeline.progress(newTime);
						},
						allowPageScroll: 'none',
					});
				}
			} else {
				$parallax.removeClass('is-hidden');
				animateClouds();

				$window.off('mousewheel');
				$window.on('mousewheel', _.throttle((event) => {
					event.preventDefault();

					clearTimeout(window.titlesStartTimeoutId);
					titlesTimeline.pause();

					let progress = titlesTimeline.progress();
					let progressStep;
					let newTime;

					if ($html.hasClass('is-browser-safari')) {
						progressStep = 0.01;
					} else {
						progressStep = 0.03;
					}

					if (progress >= 0.2) {
						changeTitles();
					}

					if (event.deltaY > 0) {
						progressStep = -progressStep;
					}

					newTime = progress + progressStep;

					if (newTime < 0) {
						newTime = 0;
					}

					titlesTimeline.progress(newTime);
				}, 25));
			}

			queryPush({
				name: null,
				hero: null,
			}, 'about');

			TweenMax.to($('.top-menu__item:first-child > .top-menu__item__line').removeClass('is-active'), 0.5, {
				width: '0%',
			});

			TweenMax.to($('.top-menu__item:last-child > .top-menu__item__line').removeClass('is-active'), 1, {
				width: '100%',
			});

			changePathCounter('about');

			Share._metaUpdateByPageData(pagesData.map);

			window.menuAboutLocked = false;
			window.aboutInitialized = true;
		},
		videoHide($introVideo) {
			let videoHideTimeline = new TimelineMax({
				onStart() {
					$html.removeClass('ready-to-scroll page-video');
				},
				onComplete() {
					$introVideo.remove();
					$screenVideo.addClass('is-hidden');
					$screenMain.removeClass('is-hidden');
					animObj.mainShow();
				},
			});

			videoHideTimeline.to([$('.screen-video').children().eq(0), $skipButton], 0.8, {
				autoAlpha: 0,
				clearProps: 'all',
			});
		},
		mainShow() {
			let soundPos;

			if ($window.outerWidth() >= 1440) {
				soundPos = -130;
			} else {
				soundPos = -115;
			}

			if (showMainTimeline) {
				showMainTimeline.kill();
				showMainTimeline = null;
			}

			showMainTimeline = new TimelineMax({
				onStart() {
					queryPush({
						name: 'main',
					}, '/');
				},
				onComplete() {
					$html.addClass('ready-to-scroll page-main');

					if (!simpleSound) {
						audioInit();
						simpleSound.play(true);
					}

					$mainPageContentBg.on('click', () => {
						if ($html.hasClass('ready-to-scroll')) {
							animObj.mainHide();
						}
					});

					changePathCounter(location.search);
				},
				ease: Linear.easeNone,
			});

			showMainTimeline
				.from([$mainScreenBg, $parallax], 1.5, {
					onStart() {
						animateClouds();
					},
					autoAlpha: 0,
					clearProps: 'all',
				})
				.from([$mainPageLogo, $mainPageProject, $mainPageVendor], 0.5, {
					autoAlpha: 0,
					y: -100,
					clearProps: 'all',
				})
				.from($mainPagePhone, 0.5, {
					autoAlpha: 0,
					y: 100,
					clearProps: 'all',
				}, '-=0.5')
				.from($mainPageContentBg, 0.7, {
					autoAlpha: 0,
					y: -20,
					clearProps: 'all',
				})
				.from($mainPageContentTitle, 0.5, {
					autoAlpha: 0,
					clearProps: 'all',
				})
				.from([$mainPageContentDescription, $mainPageTopMenu], 0.5, {
					autoAlpha: 0,
					clearProps: 'all',
				})
				.from($mainPageContentButton, 0.4, {
					autoAlpha: 0,
					y: -30,
					clearProps: 'all',
				})
				.from($mainPageSocial, 0.3, {
					width: 0,
					clearProps: 'all',
				}, '-=0.4')
				.from($mainPageSound, 0.3, {
					x: soundPos,
					clearProps: 'all',
				}, '-=0.4');

			window.mainInitialized = true;
		},
		mainHide(toAbout) {
			if (toAbout && showMainTimeline) {
				showMainTimeline.pause().kill();
			}

			if (toAbout) {
				window.menuAboutLocked = true;
			}

			if (hideMainTimeline) {
				hideMainTimeline.kill();
				hideMainTimeline = null;
			}

			hideMainTimeline = new TimelineMax({
				onStart() {
					$html.removeClass('ready-to-scroll page-main');
				},
				onComplete() {
					if (toAbout) {
						animObj.aboutShow();
					} else {
						animObj.mapShow();
					}
				},
				ease: Linear.easeNone,
			});

			hideMainTimeline
				.to($mainPageContentButton, 0.2, {
					y: 2,
					autoAlpha: 0,
				})
				.to([$mainPageContentTitle, $mainPageContentDescription], 0.25, {
					autoAlpha: 0,
					y: -30,
					clearProps: 'all',
				})
				.to($mainPageContentBg, 0.25, {
					scale: 8,
					clearProps: 'all',
					onComplete() {
						$screenMain.addClass('is-hidden');

						if (!toAbout) {
							$screenMap.removeClass('is-hidden');
						}
					},
				}, '-=0.25');
		},
		mapShow() {
			window.canGoToMap = false;
			window.canGoToAbout = false;

			[$('.route'), $mapPageTitle, $mapPageDescription, $mapPageFinger, $mapPageFinger.children(), $mapPageCard, $mapPageBg].forEach((e) => {
				$(e).removeAttr('style');
			});

			if (showMapTimeline) {
				showMapTimeline.kill();
				showMapTimeline = null;
			}

			showMapTimeline = new TimelineMax({
				onStart() {
					$html.removeClass('ready-to-scroll');
					$screenMap.add($parallax).removeClass('is-hidden');
					$screenMap.siblings('.screen-hero, .screen-info').addClass('is-hidden');
					queryPush({
						name: 'map',
						hero: null,
					}, '/');

					window.canGoToMap = true;
					window.canGoToAbout = true;
				},
				onComplete() {
					changePathCounter(location.search);
					window.menuMapLocked = false;
					window.canGoToMap = true;
				},
				ease: Linear.easeNone,
			});

			showMapTimeline
				.from($mapPageFade, 1.5, {
					autoAlpha: 0,
					clearProps: 'all',
					ease: Linear.easeNone,
					onStart() {
						animateClouds();
					},
				})
				.to($('.top-menu__item:last-child > .top-menu__item__line'), 0.5, {
					width: '0%',
				}, 0)
				.to($('.top-menu__item:first-child > .top-menu__item__line'), 1.3, {
					width: '100%',
				}, 0)
				.from($mapPageRouteBg, 1.5, {
					width: 0,
					autoAlpha: 0,
					clearProps: 'all',
				}, '-=1')
				.staggerFrom($mapPageRouteItems, 1, {
					autoAlpha: 0,
					y: -5,
					clearProps: 'all',
				}, 0.1, '-=1.2')
				.from($mapPageCard, 0.3, {
					y: $mapPageCard.outerHeight(),
					clearProps: 'all',
				})
				.from($mapPageTitle, 0.3, {
					autoAlpha: 0,
					y: -20,
					clearProps: 'all',
				}, '-=0.3')
				.from($mapPageDescription, 0.2, {
					autoAlpha: 0,
					delay: 0.2,
					clearProps: 'all',
					onComplete() {
						$html.addClass('ready-to-scroll page-map');
					},
				}, '-=0.1')
				.from($mapPageFinger.children().eq(0), 0.4, {
					autoAlpha: 0,
					clearProps: 'all',
				})
				.from($mapPageFinger.children().eq(1), 0.25, {
					autoAlpha: 0,
					clearProps: 'all',
				})
				.to($mapPageFinger.children().eq(1), 0.45, {
					y: -10,
					clearProps: 'all',
					repeat: 3,
					yoyo: true,
					ease: Linear.easeNone,
				});

			window.mapInitialized = true;
		},
		mapShowAfterAbout() {
			let timeline = new TimelineMax({
				onStart() {
					$html.removeClass('ready-to-scroll page-about');
					$html.addClass('ready-to-scroll page-map');
				},
				onProgress() {
					window.canGoToAbout = false;
				},
				onComplete() {
					if (titlesTimeline) {
						titlesTimeline.seek(0);
						titlesTimeline.pause();
					}

					$screenAbout.addClass('is-hidden');
					$screenMap.removeClass('is-hidden');
					window.canGoToAbout = true;
					animObj.mapShow();
				},
				ease: Linear.easeNone,
			});

			timeline
				.to($screenAbout.find('.screen--about__content'), 1, {
					autoAlpha: 0,
				});
		},
		mapHide(item, toAbout) {
			if (toAbout && showMapTimeline) {
				showMapTimeline.pause().kill();
			}

			if (!toAbout) {
				window.canGoToAbout = false;
			}

			if (toAbout) {
				window.menuAboutLocked = true;
			}

			let itemLeft;
			let itemTop;
			let itemNumber;

			if (!item) {
				itemLeft = $window.outerWidth() / 2;
				itemTop = $window.outerHeight() / 2;
				itemNumber = 1;
			} else {
				itemLeft = item.offset().left;
				itemTop = item.offset().top;
				itemNumber = item.data('item');
			}

			if (hideMapTimeline) {
				hideMapTimeline.kill();
				hideMapTimeline = null;
			}

			hideMapTimeline = new TimelineMax({
				onStart() {
					$html.removeClass('ready-to-scroll page-map');
				},
				onProgress() {
					if (!toAbout) {
						window.canGoToAbout = false;
					}
				},
				onComplete() {
					$screenMap.addClass('is-hidden');

					if (toAbout) {
						animateClouds();
						animObj.aboutShow();
					} else {
						animObj.showHero(itemNumber);

						if (!toAbout) {
							window.canGoToAbout = true;
						}
					}
				},
				ease: Linear.easeNone,
			});

			hideMapTimeline
				.to([$mapPageRoute, $mapPageTitle], 1, {
					autoAlpha: 0,
				})
				.to($mapPageDescription, 0.5, {
					autoAlpha: 0,
				}, '-=1')
				.to($mapPageFinger, 0.5, {
					autoAlpha: 0,
					y: 10,
				}, '-=1')
				.to($mapPageBg, 1, {
					autoAlpha: 0,
					scale: 4,
					x: ($window.outerWidth() / 2 - itemLeft) * 4,
					y: $window.outerHeight() / 2 - itemTop,
					force3D: true,
				})
				.to($parallax.find('.parallax__item--01'), 1, {
					x: -1500,
					y: 1000,
					scale: 4,
					autoAlpha: 0,
					force3D: true,
				}, '-=1')
				.to($parallax.find('.parallax__item--02'), 1, {
					x: -1500,
					y: -350,
					scale: 4,
					autoAlpha: 0,
					force3D: true,
				}, '-=1')
				.to($parallax.find('.parallax__item--03'), 1, {
					x: 2300,
					y: -150,
					scale: 4,
					autoAlpha: 0,
					force3D: true,
				}, '-=1')
				.to($parallax.find('.parallax__item--04'), 1, {
					x: 250,
					y: 700,
					scale: 4,
					autoAlpha: 0,
					force3D: true,
				}, '-=1')
				.to($parallax.find('.parallax__item--05'), 1, {
					x: -150,
					y: -700,
					scale: 4,
					autoAlpha: 0,
					force3D: true,
				}, '-=1')
				.to($mapPageCard, 0.5, {
					y: $mapPageCard.outerHeight(),
				}, '-=0.5');
		},
		switchHeroNext() {
			let $currentHero = $screenHero.not('.is-hidden');
			let currentData = parseInt($currentHero.data('item'), 10);

			let $screenOverlay = $('.screen-overlay');

			let $currentHeroLogo = $currentHero.find('.logo');
			let $currentHeroProject = $currentHero.find('.project');
			let $currentHeroMenu = $currentHero.find('.top-menu');
			let $currentHeroVendor = $currentHero.find('.vendor');
			let $currentHeroPhone = $currentHero.find('.phone');
			let $currentHeroCard = $currentHero.find('.card');
			let $currentHeroMap = $currentHero.find('.mini-map');
			let $currentHeroSocial = $currentHero.find('.social');
			let $currentHeroSound = $currentHero.find('.sound');

			let $allCurrent = [
				$currentHeroLogo,
				$currentHeroProject,
				$currentHeroMenu,
				$currentHeroVendor,
				$currentHeroPhone,
				$currentHeroCard,
				$currentHeroMap,
				$currentHeroSocial,
				$currentHeroSound,
			];

			if (currentData === 11) {
				currentData = 0;
			}

			if (hideHeroTimeline) {
				hideHeroTimeline.seek(0).pause().kill();
			}

			if (showInfoTimeline) {
				showInfoTimeline.seek(0).pause().kill();
			}

			let $nextHero = $screenHero.filter(`[data-item="${currentData + 1}"]`);

			let $nextHeroLogo = $nextHero.find('.logo');
			let $nextHeroProject = $nextHero.find('.project');
			let $nextHeroMenu = $nextHero.find('.top-menu');
			let $nextHeroVendor = $nextHero.find('.vendor');
			let $nextHeroPhone = $nextHero.find('.phone');
			let $nextHeroCard = $nextHero.find('.card');
			let $nextHeroMap = $nextHero.find('.mini-map');
			let $nextHeroSocial = $nextHero.find('.social');
			let $nextHeroSound = $nextHero.find('.sound');
			let $nextHeroContent = $nextHero.find('.screen-hero__content').removeAttr('style'); // eslint-disable-line

			let $allNext = [
				$nextHeroLogo,
				$nextHeroProject,
				$nextHeroMenu,
				$nextHeroVendor,
				$nextHeroPhone,
				$nextHeroCard,
				$nextHeroMap,
				$nextHeroSocial,
				$nextHeroSound,
			];

			$screenOverlay.removeClass('is-hidden');

			let switchNextTimeline = new TimelineMax({
				onStart() {
					$html.removeClass('ready-to-scroll');

					$allNext.forEach((e) => {
						$(e).addClass('is-hidden');
					});
				},
				onComplete() {
					$html.addClass('ready-to-scroll');

					$screenOverlay.addClass('is-hidden');

					$currentHero.addClass('is-hidden');

					queryPush({
						hero: currentData + 1,
					}, '/');

					Share._metaUpdateByPageData(pagesData[`hero-${currentData + 1}`]);

					$allNext.forEach((e) => {
						$(e).removeClass('is-hidden');
					});

					$allNext.concat($allCurrent).forEach((e) => {
						$(e).removeAttr('style');
					});

					$window.off('mousewheel');

					$window.one('mousewheel', _.throttle((event) => {
						let delta = event.deltaY;

						if ($html.hasClass('page-hero') && $html.hasClass('ready-to-scroll') && delta < 0) {
							animObj.hideHero(parseInt(currentData + 1, 10));

							let thisName = $screenHero.not('.is-hidden').data('name');

							ga('send', 'event', 'hero', 'intro by scroll', thisName);
						}
					}, 1000, {
						trailing: false,
					}));

					// Hero play button

					$heroBigPhoneButton.off('click');
					$nextHero.find($heroBigPhoneButton).one('click', () => {
						animObj.hideHero(parseInt(currentData + 1, 10));
					});
				},
			});

			switchNextTimeline
				.set($nextHero, {
					x: $currentHero.outerWidth(),
					force3D: true,
				})
				.to($allCurrent, 0, {
					autoAlpha: 0,
					force3D: true,
				})
				.to($currentHero, 1, {
					onStart() {
						$nextHero.removeClass('is-hidden');
						$nextButton.add($prevButton).addClass('is-hidden');
					},
					x: -$currentHero.outerWidth(),
					force3D: true,
					clearProps: 'all',
				}, 'switch')
				.to($nextHero, 1, {
					x: 0,
					force3D: true,
					clearProps: 'all',
					onComplete() {
						$nextButton.add($prevButton).removeClass('is-hidden');
					},
				}, 'switch');
		},
		switchHeroPrev() {
			let $currentHero = $screenHero.not('.is-hidden');
			let currentData = parseInt($currentHero.data('item'), 10);
			let $screenOverlay = $('.screen-overlay');

			let $currentHeroLogo = $currentHero.find('.logo');
			let $currentHeroProject = $currentHero.find('.project');
			let $currentHeroMenu = $currentHero.find('.top-menu');
			let $currentHeroVendor = $currentHero.find('.vendor');
			let $currentHeroPhone = $currentHero.find('.phone');
			let $currentHeroCard = $currentHero.find('.card');
			let $currentHeroMap = $currentHero.find('.mini-map');
			let $currentHeroSocial = $currentHero.find('.social');
			let $currentHeroSound = $currentHero.find('.sound');

			let $allCurrent = [
				$currentHeroLogo,
				$currentHeroProject,
				$currentHeroMenu,
				$currentHeroVendor,
				$currentHeroPhone,
				$currentHeroCard,
				$currentHeroMap,
				$currentHeroSocial,
				$currentHeroSound,
			];

			if (currentData === 1) {
				currentData = 12;
			}

			let $prevHero = $screenHero.filter(`[data-item="${currentData - 1}"]`);

			let $prevHeroLogo = $prevHero.find('.logo');
			let $prevHeroProject = $prevHero.find('.project');
			let $prevHeroMenu = $prevHero.find('.top-menu');
			let $prevHeroVendor = $prevHero.find('.vendor');
			let $prevHeroPhone = $prevHero.find('.phone');
			let $prevHeroCard = $prevHero.find('.card');
			let $prevHeroMap = $prevHero.find('.mini-map');
			let $prevHeroSocial = $prevHero.find('.social');
			let $prevHeroSound = $prevHero.find('.sound');
			let $prevHeroContent = $prevHero.find('.screen-hero__content').removeAttr('style'); // eslint-disable-line

			let $allPrev = [
				$prevHeroLogo,
				$prevHeroProject,
				$prevHeroMenu,
				$prevHeroVendor,
				$prevHeroPhone,
				$prevHeroCard,
				$prevHeroMap,
				$prevHeroSocial,
				$prevHeroSound,
			];

			if (hideHeroTimeline) {
				hideHeroTimeline.seek(0).pause().kill();
			}

			if (showInfoTimeline) {
				showInfoTimeline.seek(0).pause().kill();
			}

			$screenOverlay.removeClass('is-hidden');

			let switchPrevTimeline = new TimelineMax({
				onStart() {
					$html.removeClass('ready-to-scroll');

					$allPrev.forEach((e) => {
						$(e).addClass('is-hidden');
					});
				},
				onComplete() {
					$html.addClass('ready-to-scroll');

					$screenOverlay.addClass('is-hidden');

					$currentHero.addClass('is-hidden');

					queryPush({
						hero: currentData - 1,
					}, '/');

					Share._metaUpdateByPageData(pagesData[`hero-${currentData + 1}`]);

					$allPrev.forEach((e) => {
						$(e).removeClass('is-hidden');
					});

					$allPrev.concat($allCurrent).forEach((e) => {
						$(e).removeAttr('style');
					});

					$window.off('mousewheel');

					$window.one('mousewheel', _.throttle((event) => {
						let delta = event.deltaY;

						if ($html.hasClass('page-hero') && $html.hasClass('ready-to-scroll') && delta < 0) {
							animObj.hideHero(parseInt(currentData - 1, 10));

							let thisName = $screenHero.not('.is-hidden').data('name');

							ga('send', 'event', 'hero', 'intro by scroll', thisName);
						}
					}, 1000, {
						trailing: false,
					}));

					// Hero play button

					$heroBigPhoneButton.off('click');

					$prevHero.find($heroBigPhoneButton).on('click', () => {
						animObj.hideHero(parseInt(currentData - 1, 10));
					});
				},
			});

			switchPrevTimeline
				.set($prevHero, {
					x: -$currentHero.outerWidth(),
					force3D: true,
				})
				.to($allCurrent, 0, {
					autoAlpha: 0,
					force3D: true,
				})
				.to($currentHero, 1, {
					onStart() {
						$prevHero.removeClass('is-hidden');
						$nextButton.add($prevButton).addClass('is-hidden');
					},
					x: $currentHero.outerWidth(),
					force3D: true,
					clearProps: 'all',
				}, 'switch')
				.to($prevHero, 1, {
					x: 0,
					force3D: true,
					clearProps: 'all',
					onComplete() {
						$nextButton.add($prevButton).removeClass('is-hidden');
					},
				}, 'switch');
		},
		showHero(number) {
			window.canGoToAbout = false;

			if (!number) {
				number = queryParse('object').hero || 1;
			}

			if (number > 11) {
				number = 1;
			}

			Share._metaUpdateByPageData(pagesData[`hero-${number}`]);

			let $currentHero = $screenHero.filter(`[data-item='${number}']`);

			if (showHeroTimeline) {
				showHeroTimeline.seek(0).kill();
				showHeroTimeline = null;
			}

			[
				$currentHero.find($heroPageFade),
				$currentHero.find($heroPageBg),
				$currentHero.find($heroPageContentTitle).add($currentHero.find($heroPageContentDescription)),
				$currentHero.find($heroPageContentText).add($currentHero.find($heroPageContentCity)),
				$currentHero.find($heroPageCoordinates),
				$currentHero.find($heroBigPhone),
				$currentHero.find($heroBigPhoneButton),
				$currentHero.find($heroPageCard),
				$currentHero.find($heroMiniMap),
			].forEach(($element) => {
				$element.removeAttr('style');
			});

			showHeroTimeline = new TimelineMax({
				ease: Linear.easeNone,
				onStart() {
					$screenMap.addClass('is-hidden');
					$currentHero.removeClass('is-hidden');
					$prevButton.add($nextButton).removeClass('is-hidden');
				},
				onProgress() {
					window.canGoToAbout = false;
					window.menuAboutLocked = true;
				},
				onComplete() {
					$html.addClass('ready-to-scroll page-hero');
					checkAudio();

					queryPush({
						name: 'hero',
						hero: number,
					}, '/');

					$window.one('mousewheel', _.throttle((event) => {
						let delta = event.deltaY;

						if ($html.hasClass('page-hero') && $html.hasClass('ready-to-scroll') && delta < 0) {
							animObj.hideHero(parseInt(number, 10));

							let thisName = $screenHero.not('.is-hidden').data('name');

							ga('send', 'event', 'hero', 'intro by scroll', thisName);
						}
					}, 1000, {
						trailing: false,
					}));

					// Hero play button

					$currentHero.find($heroBigPhoneButton).on('click', () => {
						animObj.hideHero(parseInt(number, 10));
					});

					$heroPageBgMap.removeClass('is-hidden');

					changePathCounter(location.search);

					setTimeout(() => {
						window.canGoToAbout = true;
						window.menuAboutLocked = false;
					}, 50);
				},
			});

			showHeroTimeline
				.from($currentHero.find($heroPageFade), 1, {
					autoAlpha: 0,
					clearProps: 'all',
				}, 'start')
				.from($currentHero.find($heroPageBg), 1, {
					autoAlpha: 0,
					clearProps: 'all',
				}, 'start')
				.from($currentHero.find($heroPageContentTitle).add($currentHero.find($heroPageContentDescription)), 0.4, {
					autoAlpha: 0,
					y: -5,
					clearProps: 'all',
				})
				.from($currentHero.find($heroPageContentText).add($currentHero.find($heroPageContentCity)), 0.4, {
					autoAlpha: 0,
					y: -5,
					clearProps: 'all',
				})
				.from($currentHero.find($heroPageCoordinates), 0.4, {
					autoAlpha: 0,
					clearProps: 'all',
				}, '-=0.4')
				.from($currentHero.find($heroBigPhone), 0.4, {
					autoAlpha: 0,
					y: -10,
				})
				.from($currentHero.find($heroBigPhoneButton), 0.4, {
					autoAlpha: 0,
					clearProps: 'all',
				})
				.from($currentHero.find($heroPageCard), 0.3, {
					y: $currentHero.find($heroPageCard).outerHeight(),
					clearProps: 'all',
					force3D: true,
				}, '-=0.3')
				.from($currentHero.find($heroMiniMap), 0.4, {
					autoAlpha: 0,
					x: 10,
					clearProps: 'all',
				}, '-=0.4');
		},
		hideHero(number, toAbout, toMap) {
			if (toAbout && !window.canGoToAbout) {
				return;
			}

			if (toMap && !window.canGoToMap) {
				return;
			}

			if ((toAbout || toMap) && showHeroTimeline && showHeroTimeline.progress() < 0.9) {
				return;
			}

			if (toAbout) {
				window.menuAboutLocked = true;
			}

			if (toMap) {
				window.menuMapLocked = true;
			}

			if (!number) {
				number = queryParse('object').hero || 1;
			}

			$window.off('mousewheel.show');

			let $currentHero = $screenHero.filter(`[data-item=${number}]`);
			let $heroVideo = $currentHero.find('.hero-video');
			let $heroSound = $currentHero.find('.sound');
			let $heroVideoNav = $heroVideo.find('.hero-video__nav');
			let $heroVideoClose = $heroVideo.find('.hero-video__button');
			let $heroPlayVideo = $currentHero.find('.hero-video__nav').children().eq(1);
			let $heroRestartVideo = $currentHero.find('.hero-video__nav').children().eq(0);

			if (window._currentHeroVideo) {
				window._currentHeroVideo.stop();
				window._currentHeroVideo.remove();
			}

			if (hideHeroTimeline) {
				hideHeroTimeline.kill();
				hideHeroTimeline = null;
			}

			hideHeroTimeline = new TimelineMax({
				onStart() {
					$html.removeClass('page-hero ready-to-scroll');
					$heroPageBgMap.addClass('is-hidden');

					if (!toAbout && !toMap) {
						if (simpleSound) {
							TweenMax.to({
								volume: simpleSound.getVolume(),
							}, 1.5, {
								volume: 0,
								onUpdate() {
									simpleSound.setVolume(this.target.volume);
								},
								onComplete() {
									simpleSound.play(false);
								},
							});
						}
					}

					$nextButton.add($prevButton).addClass('is-hidden');
				},
				onProgress() {
					if (!toAbout && !toMap) {
						window.canGoToAbout = false;
						window.canGoToMap = false;
					}
				},
				onComplete() {
					if (toAbout || toMap) {
						if (window._currentHeroVideo) {
							let timeline = new TimelineMax({
								ease: Linear.easeNone,
							});

							TweenMax.to({
								volume: 100,
							}, 1, {
								volume: 0,
								onUpdate() {
									window._currentHeroVideo.setVolume(this.target.volume);
								},
								onComplete() {
									window._currentHeroVideo.stop();
									window._currentHeroVideo.remove();
								},
							});

							timeline.to([$heroVideoNav, $heroVideo], 0.7, {
								autoAlpha: 0,
								onComplete() {
									$currentHero.addClass('is-hidden');
								},
							});

							simpleSound.play(true);

							checkAudio();
						}

						animateClouds();

						if (toAbout) {
							animObj.aboutShow();
						} else {
							animObj.mapShow();
						}
					} else {
						let videoContainer = $heroVideo
							.find('.hero-video__container')
							.attr('id', `id-hero-video-${Date.now()}`)
							.get(0);

						let heroVideo = jwplayer(videoContainer).setup({
							width: '100%',
							height: '100%',
							stretching: 'fill',
							autostart: !bowser.ipad,
							controls: true,
							mute: false,
							skin: {
								name: 'samsung',
							},
							playlist: [{
								file: videoList[number],
								tracks: number === 2 ? [{
									'file': '/vtt/habarovsk.vtt',
									'label': 'Russian',
									'kind': 'captions',
									'default': true,
								}] : undefined,
							}],
							captions: {
								fontSize: 12,
							},
						});

						window._currentHeroVideo = heroVideo;

						heroVideo.setVolume(0);

						heroVideo.onDisplayClick(() => {
							heroVideo.play(true);
						});

						if ($heroSound.hasClass('is-off')) {
							TweenMax.to({
								volume: heroVideo.getVolume(),
							}, 1.5, {
								volume: 0,
								onUpdate() {
									heroVideo.setVolume(this.target.volume);
								},
							});
						} else {
							TweenMax.to({
								volume: heroVideo.getVolume(),
							}, 1.5, {
								volume: 100,
								ease: Linear.easeNone,
								onUpdate() {
									heroVideo.setVolume(this.target.volume);
								},
							});
						}

						$heroSound.on('click', (event) => {
							let $this = $(event.currentTarget);

							if (!$this.hasClass('is-off')) {
								TweenMax.to({
									volume: heroVideo.getVolume(),
								}, 1.5, {
									volume: 100,
									ease: Linear.easeNone,
									onUpdate() {
										heroVideo.setVolume(this.target.volume);
									},
								});
							} else {
								TweenMax.to({
									volume: heroVideo.getVolume(),
								}, 1.5, {
									volume: 0,
									ease: Linear.easeNone,
									onUpdate() {
										heroVideo.setVolume(this.target.volume);
									},
								});
							}
						});

						$heroPlayVideo.off('click');
						$heroPlayVideo.on('click', (event) => {
							let $this = $(event.currentTarget);

							heroVideo.pause();

							if (!$this.hasClass('is-off')) {
								ga('send', 'event', 'hero', 'intro controls', 'pause');
							} else {
								if ($this.hasClass('is-paused-before')) {
									ga('send', 'event', 'hero', 'intro controls', 'resume');
								}
								ga('send', 'event', 'hero', 'intro controls', 'play');
							}
						});

						$heroVideoClose = $currentHero.find('.button-video-close');
						$heroVideoClose.off('click');
						$heroVideoClose.on('click', () => {
							ga('send', 'event', 'hero', 'intro controls', 'finish');

							setTimeout(() => {
								$heroVideoClose.addClass('is-hidden');
								$heroVideoNav.addClass('is-hidden');
							}, 1000);

							animObj.showInfo(number, heroVideo, $heroVideoNav, $heroVideo, $currentHero);

							simpleSound.play(true);

							checkAudio();
						});

						$heroRestartVideo.off('click');
						$heroRestartVideo.on('click', () => {
							location.reload();
						});

						heroVideo.on('complete', () => {
							animObj.showInfo(number, heroVideo, $heroVideoNav, $heroVideo, $currentHero);

							simpleSound.play(true);

							checkAudio();

							let thisName = $screenHero.not('.is-hidden').data('name');

							ga('send', 'event', 'intro', 'finish', thisName);
						});

						heroVideo.on('play', () => {
							if (heroVideo.getPosition() === 0) {
								let thisName = $screenHero.not('.is-hidden').data('name');

								ga('send', 'event', 'intro', 'start', thisName);
							}

							if ($heroPlayVideo.hasClass('is-paused-before')) {
								$heroPlayVideo.toggleClass('is-off');
							}

							$heroPlayVideo.addClass('is-paused-before');
						});

						heroVideo.on('pause', () => {
							$heroPlayVideo.addClass('is-paused-before');
							$heroPlayVideo.toggleClass('is-off');
						});

						$heroVideoNav.removeClass('is-hidden');
						$heroVideoClose.removeClass('is-hidden');

						$html.addClass('page-hero-video ready-to-scroll');
					}
				},
			});

			hideHeroTimeline
				.to($currentHero.find($heroBigPhoneButton), 0.35, {
					y: 5,
					autoAlpha: 0,
				})
				.to($currentHero.find($heroBigPhone), 0.35, {
					scale: 5,
					autoAlpha: 0,
				})
				.to($currentHero.find($heroPageCoordinates
					.add($heroPageContentCity)
					.add($heroPageContentTitle)
					.add($heroPageContentDescription)
					.add($heroPageContentText)
					.add($heroMiniMap)
				), 0.3, {
					autoAlpha: 0,
					x: -20,
					onComplete() {
						$currentHero.find($heroPageContent).css({
							'z-index': 6,
						});
					},
				}, '-=0.35')
				.to($currentHero.find($heroPageCard), 0.2, {
					y: $currentHero.find($heroPageCard).outerHeight(),
				})
				.to($currentHero.find($heroPageBg), 0.5, {
					autoAlpha: 0,
				}, '-=0.3');

			if (!toAbout && !toMap) {
				hideHeroTimeline.to([$heroVideo, $heroVideoNav], 0.5, {
					autoAlpha: 1,
				});

				window.videoInitialized = true;
			}
		},
		showInfo(number, video, videoNav, videoLine, hero) {
			if (!number) {
				number = queryParse('object').hero || 1;
			}

			Share._metaUpdateByPageData(pagesData[`hero-${number}`]);

			$window.off('mousewheel');

			let $currentInfo = $screenInfo.filter(`[data-item=${number}]`);
			let $infoContent = $currentInfo.find('.screen-info__content');
			let $infoContentWrap = $currentInfo.find('.screen-info__content__wrap');
			let $infoCard = $currentInfo.find('.card');
			let $infoMiniMap = $currentInfo.find('.mini-map');
			let $infoContentBg = $currentInfo.find('.screen-info__bg');
			let $infoContentMap = $currentInfo.find('.screen-info__bg-map');
			let mediaElements = [];

			window.currentMediaElements = mediaElements;

			if (showInfoTimeline) {
				showInfoTimeline.kill();
				showInfoTimeline = null;
			}

			showInfoTimeline = new TimelineMax({
				onStart() {
					$html.removeClass('ready-to-scroll page-hero-video');
				},
				onComplete() {
					$infoPageBgMap.removeClass('is-hidden');

					queryPush({
						name: 'info',
						hero: number,
					}, '/');

					let innerWidth = 0;

					$infoContent.children().each((i, e) => {
						innerWidth += $(e).outerWidth(true);
					});

					let scrollTimeline = new TimelineMax({
						paused: true,
						onUpdate() {
							if (scrollTimeline.progress() === 1) {
								$html.addClass('ready-to-switch');
							} else {
								$html.removeClass('ready-to-switch');
							}
						},
						onComplete() {
							let counter = 1;
							let timeOut;
							let itemToScroll;

							if ($html.hasClass('is-browser-safari')) {
								itemToScroll = 11;
							} else {
								itemToScroll = 7;
							}

							let edgeTimeline = new TimelineMax({
								paused: true,

								onStart() {
									$infoContentMap.addClass('is-hidden');
									$html.removeClass('ready-to-scroll');
								},

								onComplete() {
									edgeTimeline.seek(0).pause();
									$infoContentMap.removeClass('is-hidden');
									$html.addClass('ready-to-scroll');
								},
							});

							edgeTimeline
								.set($currentInfo, {
									'background-position-x': `${$currentInfo.outerWidth()}px`,
								})
								.to([$infoContentWrap, $infoContentBg], 0.3, {
									x: -150,
									ease: Linear.easeNone,
								}, 'step-1')
								.to($currentInfo, 0.3, {
									'background-position-x': '-=150',
									'background-position-y': '0,',
									'ease': Linear.easeNone,
								}, 'step-1')
								.to([$infoContentWrap, $infoContentBg], 0.3, {
									x: 0,
									ease: Linear.easeNone,
								}, 'step-2')
								.to($currentInfo, 0.3, {
									'background-position-x': `${$currentInfo.outerWidth()}px`,
									'background-position-y': '0,',
									'ease': Linear.easeNone,
								}, 'step-2');

							let switchNext = _.throttle((event) => {
								if (event.deltaY < 0 && $html.hasClass('ready-to-switch')) {
									counter += 1;

									if (counter >= itemToScroll) {
										[$currentInfo, $infoContentWrap, $infoContentBg].forEach((e) => {
											$(e).removeAttr('style');
										});
										$html.removeClass('ready-to-switch');
										$window.off('mousewheel.next');
										edgeTimeline.stop().seek(1).kill();

										mediaElements.forEach((e) => {
											TweenMax.to({
												volume: e.getVolume(),
											}, 1, {
												volume: 0,
												onComplete() {
													e.stop();
													e.remove();
												},
												onUpdate() {
													e.setVolume(this.target.volume);
												},
											});
										});

										let thisName = $screenInfo.not('.is-hidden').data('name');

										ga('send', 'event', 'hero', 'scroll bottom', thisName);

										animObj.nextHero($currentInfo, $infoContent, number);
									} else {
										setTimeout(() => {
											if ($html.hasClass('ready-to-switch')) {
												edgeTimeline.play();
											}
										}, 210);
									}

									timeOut = setTimeout(() => {
										if (counter < itemToScroll) {
											counter = 1;

											clearTimeout(timeOut);
										}
									}, 200);
								}
							}, 20);

							$window.off('mousewheel.next');

							setTimeout(() => {
								$window.on('mousewheel.next', switchNext);
							}, 800);

							if (window.innerWidth > 1024 && $html.hasClass('is-device-touch')) {
								$window.off('switchHero');

								$window.on('switchHero', () => {
									[$currentInfo, $infoContentWrap, $infoContentBg].forEach((e) => {
										$(e).removeAttr('style');
									});

									$html.addClass('ready-to-switch');
									$window.swipe('destroy');
									$window.off('mousewheel.next');

									mediaElements.forEach((e) => {
										TweenMax.to({
											volume: e.getVolume(),
										}, 1, {
											volume: 0,
											onComplete() {
												e.stop();
												e.remove();
											},
											onUpdate() {
												e.setVolume(this.target.volume);
											},
										});
									});

									let thisName = $screenInfo.not('.is-hidden').data('name');

									ga('send', 'event', 'hero', 'scroll bottom', thisName);

									animObj.nextHero($currentInfo, $infoContent, number);
								});
							}
						},
					});

					scrollTimeline.to($infoContent, 2, {
						x: -innerWidth + $window.outerWidth() - 50,
						ease: Linear.easeNone,
						force3D: true,
					});

					$window.off('mousewheel.scroll');
					$window.on('mousewheel.scroll', _.throttle((event) => {
						event.preventDefault();

						if ($html.hasClass('page-info') && $html.hasClass('ready-to-scroll')) {
							let progress = scrollTimeline.progress();
							let progressStep;
							let newTime;

							if (event.deltaY < 0) {
								progressStep = -(-1 / 35);
							} else {
								progressStep = -(1 / 35);
							}

							newTime = (progress + progressStep) * scrollTimeline.duration();

							if (newTime < 0) {
								newTime = 0;
							}

							scrollTimeline.tweenTo(newTime, {
								ease: Linear.easeNone,
							});
						}
					}, 10));

					if (window.innerWidth > 1024 && $html.hasClass('is-device-touch')) {
						$window.swipe('destroy');

						$window.swipe({
							excludedElements: [],
							swipeLeft() {
								if (scrollTimeline.progress() === 1) {
									$window.trigger('switchHero');

									return;
								}

								let time = (scrollTimeline.progress() + 0.25) * scrollTimeline.duration();

								scrollTimeline.tweenTo(Math.max(0, Math.min(time, scrollTimeline.duration())));
							},
							swipeRight() {
								let time = (scrollTimeline.progress() - 0.25) * scrollTimeline.duration();

								scrollTimeline.tweenTo(Math.max(0, Math.min(time, scrollTimeline.duration())));
							},
						});
					}

					// Sound elements

					let $soundItems = $currentInfo.find('.sound-item');

					$soundItems.each((i, e) => {
						let soundItem = soundItemsInit($(e), `/audio/hero-${number}-sound-${i + 1}.mp3`);

						mediaElements.push(soundItem);
					});

					// Video elements

					let $videoItems = $currentInfo.find('.video-item');

					$videoItems.each((i, e) => {
						let videoItem = videoItemsInit($(e), videoList.content[number][i + 1], `/images/video/hero-${number}-video-${i + 1}.jpg`);

						mediaElements.push(videoItem);
					});

					mediaElements.forEach((e) => {
						let that = e;

						that.on('play', () => {
							mediaElements.forEach((mediaElement) => {
								if (that !== mediaElement) {
									TweenMax.to({
										volume: 100,
									}, 1, {
										volume: 0,
										onUpdate() {
											mediaElement.setVolume(this.target.volume);
										},
										onComplete() {
											mediaElement.stop();
										},
									});
								}
							});
						});
					});

					$html.addClass('ready-to-scroll page-info');

					changePathCounter(location.search);
				},
				ease: Linear.easeNone,
			});

			[
				$infoContentBg,
				$infoContent,
				$infoContentWrap,
				$currentInfo,
				$infoContent,
				$infoCard,
				$infoMiniMap,
			].forEach(($element) => {
				$element.removeAttr('style');
			});

			showInfoTimeline
				.set($infoContentBg, {
					'background-position-x': 0,
					'x': 0,
				})
				.set([$infoContent, $infoContentWrap], {
					x: 0,
					force3D: true,
				})
				.to([videoNav, videoLine], 0.7, {
					autoAlpha: 0,
					onComplete() {
						if (video) {
							video.remove();
						}

						if (window._currentHeroVideo) {
							window._currentHeroVideo.remove();
						}

						if (hero) {
							hero.addClass('is-hidden');
						}
					},
				})
				.from($currentInfo, 0.5, {
					autoAlpha: 0,
					clearProps: 'all',
					onStart() {
						$currentInfo.removeClass('is-hidden');
					},
				})
				.from($infoContent, 0.3, {
					autoAlpha: 0,
					left: 50,
					clearProps: 'all',
				})
				.from($infoCard, 0.3, {
					y: $infoCard.outerHeight(),
					clearProps: 'all',
				}, '-=0.3')
				.from($infoMiniMap, 0.3, {
					x: 10,
					autoAlpha: 0,
					clearProps: 'all',
				});
		},
		hideInfo(toAbout, toMap) {
			if (toAbout || toMap) {
				let $currentInfo = $screenInfo.not('.is-hidden');
				let $infoContent = $currentInfo.find('.screen-info__content');
				let $infoCard = $currentInfo.find('.card');
				let $infoMiniMap = $currentInfo.find('.mini-map');
				let $infoContentBg = $currentInfo.find('.screen-info__bg');

				$window.off('mousewheel');

				if (window.currentMediaElements) {
					$currentInfo.find('.video-item, .sound-item').removeClass('is-play');

					window.currentMediaElements.forEach((mediaElement) => {
						TweenMax.to({
							volume: 100,
						}, 1, {
							volume: 0,
							onUpdate() {
								mediaElement.setVolume(this.target.volume);
							},
							onComplete() {
								mediaElement.remove();
							},
						});
					});

					window.currentMediaElements = [];
				}

				checkAudio();

				let timeline = new TimelineMax({
					ease: Linear.easeNone,
					onStart() {
						if (toAbout) {
							$screenAbout.removeClass('is-hidden');
						}
					},
					onComplete() {
						$currentInfo.addClass('is-hidden');
						animateClouds();

						if (toAbout) {
							animObj.aboutShow();
						} else {
							animObj.mapShow();
						}
					},
				});

				timeline.to([$infoContent, $infoContentBg, $infoCard, $infoMiniMap], 0.5, {
					autoAlpha: 0,
				});
			}
		},
		nextHero(prevInfo, prevContent, number) {
			if (nextHeroTimeline) {
				nextHeroTimeline.kill();
				nextHeroTimeline = null;
			}

			nextHeroTimeline = new TimelineMax({
				ease: Power2.easeIn,
				onStart() {
					animObj.showHeroNext(parseInt(number, 10));
					$html.removeClass('ready-to-scroll page-info');

					$infoPageBgMap.addClass('is-hidden');
				},
				onComplete() {
					prevInfo.addClass('is-hidden');
				},
			});

			let $prevInfoBg = prevInfo.find('.screen-info__bg');
			let bgPos = prevInfo.outerWidth();

			nextHeroTimeline
				.to(prevContent.parent(), 2, {
					x: -bgPos,
					ease: Power2.easeIn,
				})
				.to($prevInfoBg, 2, {
					'background-position-x': bgPos,
					'background-position-y': 'auto',
					'x': -bgPos,
					'ease': Power2.easeIn,
				}, '-=2');
		},
		showHeroNext(number) {
			number = parseInt(number, 10);

			if (!number) {
				number = queryParse('object').hero || 1;
			}

			number += 1;

			if (number > 11) {
				number = 1;
			}

			Share._metaUpdateByPageData(pagesData[`hero-${number}`]);

			let $currentHero = $screenHero.filter(`[data-item='${number}']`);

			if (showHeroTimeline) {
				showHeroTimeline.kill();
				showHeroTimeline = null;
			}

			showHeroTimeline = new TimelineMax({
				ease: Linear.easeNone,
				onStart() {
					$html.removeClass('ready-to-scroll');
					$currentHero.removeClass('is-hidden');
				},
				onComplete() {
					$html.addClass('ready-to-scroll page-hero');
					$heroPageBgMap.removeClass('is-hidden');
					$nextButton.add($prevButton).removeClass('is-hidden');
					checkAudio();

					queryPush({
						name: 'hero',
						hero: number,
					}, '/');

					$window.one('mousewheel', _.throttle((event) => {
						let delta = event.deltaY;

						if ($html.hasClass('page-hero') && $html.hasClass('ready-to-scroll') && delta < 0) {
							animObj.hideHero(parseInt(number, 10));

							let thisName = $screenHero.not('.is-hidden').data('name');

							ga('send', 'event', 'hero', 'intro by scroll', thisName);
						}
					}, 1000, {
						trailing: false,
					}));

					// Hero play button

					$heroBigPhoneButton.off('click');

					$currentHero.find($heroBigPhoneButton).on('click', () => {
						animObj.hideHero(parseInt(number, 10));
					});

					changePathCounter(location.search);
				},
			});

			showHeroTimeline
				.from($currentHero.find($heroPageBg), 1.93, {
					x: $currentHero.outerWidth(),
					clearProps: 'all',
					ease: Power2.easeIn,
				})
				.from($currentHero.find($heroPageFade), 1, {
					autoAlpha: 0,
					clearProps: 'all',
				})
				// eslint-disable-next-line max-len
				.from($currentHero.find($heroPageContentTitle).add($currentHero.find($heroPageContentDescription)), 0.4, {
					autoAlpha: 0,
					y: -5,
					clearProps: 'all',
				})
				.from($currentHero.find($heroPageContentText).add($currentHero.find($heroPageContentCity)), 0.4, {
					autoAlpha: 0,
					y: -5,
					clearProps: 'all',
				})
				.from($currentHero.find($heroPageCoordinates), 0.4, {
					autoAlpha: 0,
					clearProps: 'all',
				}, '-=0.4')
				.from($currentHero.find($heroBigPhone), 0.4, {
					autoAlpha: 0,
					y: -10,
				})
				.from($currentHero.find($heroBigPhoneButton), 0.4, {
					autoAlpha: 0,
					clearProps: 'all',
				});
		},
		mobileHideMain() {
			let mobileHideMain = new TimelineMax({
				onStart() {
					window.scrollTo(0, 1);
					$html.removeClass('ready-to-scroll mobile-main-page');

					$window.swipe('destroy');
				},

				onComplete() {
					animObj.mobileShowHero();
					$screenMain.addClass('is-hidden');

					window.directEnter = false;
				},
			});

			mobileHideMain
				.to($mainPageContentButton, 0.2, {
					autoAlpha: 0,
				}, 'start')
				.to([$mainPageContentTitle, $mainPageContentDescription], 0.5, {
					autoAlpha: 0,
				}, 'start')
				.to($mainPageContentBg, 0.5, {
					scale: 6,
				}, 'start')
				.to([$mainScreenBg, $parallax], 1.2, {
					autoAlpha: 0,
				}, 'start');
		},
		mobileShowHero(number) {
			if (!number) {
				number = queryParse('object').hero;

				if (!number) {
					number = 1;
					window.shouldScrollToThirdHero = true;
				}
			}

			let $currentHero = $mobileSlider
				.find('.mobile-slider__content__item')
				.filter(`[data-item=${number}]`)
				.addClass('is-active');

			let $currentHeroTitle = $currentHero.find('.mobile-slider__content__item__title');
			let $currentHeroCity = $currentHero.find('.mobile-slider__content__item__city');
			let $currentHeroDescription = $currentHero.find('.mobile-slider__content__item__description');
			let $currentHeroButton = $currentHero.find('.mobile-slider__content__item__button');
			let $mobileSliderContent = $mobileSlider.find('.mobile-slider__content');

			if (mobileShowHeroTimeline) {
				mobileShowHeroTimeline.kill();
				mobileShowHeroTimeline = null;
			}

			mobileShowHeroTimeline = new TimelineMax({
				onStart() {
					$mobileSlider.removeClass('is-hidden');
					queryPush({
						name: 'hero',
						hero: number,
					}, '/');

					mobileHeroSliderTimeline.seek(`item-${number}`).pause();

					$('.mobile-slider__nav__container').attr('data-slide', number);
				},
				onComplete() {
					$html.addClass('mobile-page-hero ready-to-scroll');

					$mobileSliderItemButton.off('click');
					$mobileSliderItemButton.one('click', (event) => {
						let $this = $(event.currentTarget);
						let thisData = $this.parents('.mobile-slider__content__item').data('item');

						animObj.mobileHideHero(thisData);
					});

					$window.swipe({
						swipeLeft() {
							if ($html.hasClass('ready-to-scroll') && $html.hasClass('mobile-page-hero')) {
								mobileHeroSliderTimeline.play();
							}
						},
						swipeRight() {
							if ($html.hasClass('ready-to-scroll') && $html.hasClass('mobile-page-hero')) {
								mobileHeroSliderTimeline.reverse();
							}
						},
						threshold: 20,
						allowPageScroll: true,
						preventDefaultEvents: false,
					});

					$sliderDots.on('click', (event) => {
						let $this = $(event.currentTarget);
						let thisData = $this.data('item');

						$sliderDots.removeClass('is-active');
						$this.addClass('is-active');

						mobileHeroSliderTimeline.tweenTo(`item-${thisData}`);
						queryPush({
							hero: thisData,
						}, '/');

						$('.mobile-slider__nav__container').attr('data-slide', thisData);
					});

					$sliderDots.eq(number - 1).addClass('is-active');

					$window.one('orientationchange', () => {
						if ($html.hasClass('mobile-page-hero')) {
							location.reload();
						}
					});

					changePathCounter(location.search);
				},
			});

			mobileShowHeroTimeline
				.set([
					$sliderItems,
					$mobileSliderContent,
					$currentHeroTitle,
					$currentHeroCity,
					$currentHeroButton,
					$currentHeroDescription,
				], {
					autoAlpha: 1,
				})
				.set($currentHero, {
					scale: 1,
				})
				.set($sliderItems.not($currentHero), {
					scale: 0.9,
					force3D: true,
				})
				.set($currentHero, {
					'z-index': 11,
					'force3D': true,
				})
				.from($mobileSliderContent, 0.7, {
					autoAlpha: 0,
				}, 'start')
				.from($sliderDots, 0.3, {
					y: 50,
					clearProps: 'all',
					force3D: true,
				})
				.from([$currentHeroTitle, $currentHeroCity, $currentHeroDescription], 0.5, {
					autoAlpha: 0,
					y: -50,
					delay: 1,
					clearProps: 'all',
					force3D: true,
				}, 'start')
				.from($currentHeroButton, 0.35, {
					autoAlpha: 0,
					bottom: 40,
					clearProps: 'all',
				}, '-=0.35');

			if (mobileHeroSliderTimeline) {
				mobileHeroSliderTimeline.kill();
				mobileHeroSliderTimeline = null;
			}

			mobileHeroSliderTimeline = new TimelineMax({
				pause: true,
			});

			let sliderSpeed = 0.15;
			let itemWidth = $currentHero.outerWidth() - 17.5 * $currentHero.outerWidth() / 100;

			let $items = $('.mobile-slider__content__item');

			let $item01 = $items.eq(0);
			let $item02 = $items.eq(1);
			let $item03 = $items.eq(2);
			let $item04 = $items.eq(3);
			let $item05 = $items.eq(4);
			let $item06 = $items.eq(5);
			let $item07 = $items.eq(6);
			let $item08 = $items.eq(7);
			let $item09 = $items.eq(8);
			let $item10 = $items.eq(9);
			let $item11 = $items.eq(10);

			mobileHeroSliderTimeline
				.addLabel('item-1')
				.to($mobileSliderContent, sliderSpeed, {
					x: `-=${itemWidth}`,
					ease: Linear.easeNone,
					force3D: true,
					onComplete() {
						$('.mobile-slider__nav__container').attr('data-slide', 2);

						queryPush({
							hero: 2,
						}, '/');

						$sliderDots.removeClass('is-active');
						$sliderDots.eq(1).addClass('is-active');

						TweenMax.to($item01, sliderSpeed, {
							'scale': 0.9,
							'z-index': 10,
						});

						TweenMax.to($item02, sliderSpeed, {
							'scale': 1,
							'z-index': 11,
						});

						$items.removeClass('is-active');
						$item02.addClass('is-active');

						if (window.shouldScrollToThirdHero) {
							setTimeout(() => {
								mobileHeroSliderTimeline.play();
								window.shouldScrollToThirdHero = false;
							}, 250);
						}
					},
					onReverseComplete() {
						$('.mobile-slider__nav__container').attr('data-slide', 1);

						queryPush({
							hero: 1,
						}, '/');

						$sliderDots.removeClass('is-active');
						$sliderDots.eq(0).addClass('is-active');

						TweenMax.to($item01, sliderSpeed, {
							'scale': 1,
							'z-index': 11,
						});

						TweenMax.to($item02, sliderSpeed, {
							'scale': 0.9,
							'z-index': 10,
						});

						$items.removeClass('is-active');
						$item01.addClass('is-active');
					},
				})
				.addLabel('item-2')
				.addPause()
				.to($mobileSliderContent, sliderSpeed, {
					x: `-=${itemWidth}`,
					ease: Linear.easeNone,
					force3D: true,
					onComplete() {
						$('.mobile-slider__nav__container').attr('data-slide', 3);

						queryPush({
							hero: 3,
						}, '/');

						$sliderDots.removeClass('is-active');
						$sliderDots.eq(2).addClass('is-active');

						TweenMax.to($item02, sliderSpeed, {
							'scale': 0.9,
							'z-index': 10,
						});

						TweenMax.to($item03, sliderSpeed, {
							'scale': 1,
							'z-index': 11,
						});

						$items.removeClass('is-active');
						$item03.addClass('is-active');
					},
					onReverseComplete() {
						$('.mobile-slider__nav__container').attr('data-slide', 2);

						queryPush({
							hero: 2,
						}, '/');

						$sliderDots.removeClass('is-active');
						$sliderDots.eq(1).addClass('is-active');

						TweenMax.to($item02, sliderSpeed, {
							'scale': 1,
							'z-index': 11,
						});

						TweenMax.to($item03, sliderSpeed, {
							'scale': 0.9,
							'z-index': 10,
						});

						$items.removeClass('is-active');
						$item02.addClass('is-active');
					},
				})
				.addLabel('item-3')
				.addPause()
				.to($mobileSliderContent, sliderSpeed, {
					x: `-=${itemWidth}`,
					ease: Linear.easeNone,
					force3D: true,
					onComplete() {
						$('.mobile-slider__nav__container').attr('data-slide', 4);

						queryPush({
							hero: 4,
						}, '/');

						$sliderDots.removeClass('is-active');
						$sliderDots.eq(3).addClass('is-active');

						TweenMax.to($item03, sliderSpeed, {
							'scale': 0.9,
							'z-index': 10,
						});

						TweenMax.to($item04, sliderSpeed, {
							'scale': 1,
							'z-index': 11,
						});

						$items.removeClass('is-active');
						$item04.addClass('is-active');
					},
					onReverseComplete() {
						$('.mobile-slider__nav__container').attr('data-slide', 3);

						queryPush({
							hero: 3,
						}, '/');

						$sliderDots.removeClass('is-active');
						$sliderDots.eq(2).addClass('is-active');

						TweenMax.to($item03, sliderSpeed, {
							'scale': 1,
							'z-index': 11,
						});

						TweenMax.to($item04, sliderSpeed, {
							'scale': 0.9,
							'z-index': 10,
						});

						$items.removeClass('is-active');
						$item03.addClass('is-active');
					},
				})
				.addLabel('item-4')
				.addPause()
				.to($mobileSliderContent, sliderSpeed, {
					x: `-=${itemWidth}`,
					ease: Linear.easeNone,
					force3D: true,
					onComplete() {
						$('.mobile-slider__nav__container').attr('data-slide', 5);

						queryPush({
							hero: 5,
						}, '/');

						$sliderDots.removeClass('is-active');
						$sliderDots.eq(4).addClass('is-active');

						TweenMax.to($item04, sliderSpeed, {
							'scale': 0.9,
							'z-index': 10,
						});

						TweenMax.to($item05, sliderSpeed, {
							'scale': 1,
							'z-index': 11,
						});

						$items.removeClass('is-active');
						$item05.addClass('is-active');
					},
					onReverseComplete() {
						$('.mobile-slider__nav__container').attr('data-slide', 4);

						queryPush({
							hero: 4,
						}, '/');

						$sliderDots.removeClass('is-active');
						$sliderDots.eq(3).addClass('is-active');

						TweenMax.to($item04, sliderSpeed, {
							'scale': 1,
							'z-index': 11,
						});

						TweenMax.to($item05, sliderSpeed, {
							'scale': 0.9,
							'z-index': 10,
						});

						$items.removeClass('is-active');
						$item04.addClass('is-active');
					},
				})
				.addLabel('item-5')
				.addPause()
				.to($mobileSliderContent, sliderSpeed, {
					x: `-=${itemWidth}`,
					ease: Linear.easeNone,
					force3D: true,
					onComplete() {
						$('.mobile-slider__nav__container').attr('data-slide', 6);

						queryPush({
							hero: 6,
						}, '/');

						$sliderDots.removeClass('is-active');
						$sliderDots.eq(5).addClass('is-active');

						TweenMax.to($item05, sliderSpeed, {
							'scale': 0.9,
							'z-index': 10,
						});

						TweenMax.to($item06, sliderSpeed, {
							'scale': 1,
							'z-index': 11,
						});

						$items.removeClass('is-active');
						$item06.addClass('is-active');
					},
					onReverseComplete() {
						$('.mobile-slider__nav__container').attr('data-slide', 5);

						queryPush({
							hero: 5,
						}, '/');

						$sliderDots.removeClass('is-active');
						$sliderDots.eq(4).addClass('is-active');

						TweenMax.to($item05, sliderSpeed, {
							'scale': 1,
							'z-index': 11,
						});

						TweenMax.to($item06, sliderSpeed, {
							'scale': 0.9,
							'z-index': 10,
						});

						$items.removeClass('is-active');
						$item05.addClass('is-active');
					},
				})
				.addLabel('item-6')
				.addPause()
				.to($mobileSliderContent, sliderSpeed, {
					x: `-=${itemWidth}`,
					ease: Linear.easeNone,
					force3D: true,
					onComplete() {
						$('.mobile-slider__nav__container').attr('data-slide', 7);

						queryPush({
							hero: 7,
						}, '/');

						$sliderDots.removeClass('is-active');
						$sliderDots.eq(6).addClass('is-active');

						TweenMax.to($item06, sliderSpeed, {
							'scale': 0.9,
							'z-index': 10,
						});

						TweenMax.to($item07, sliderSpeed, {
							'scale': 1,
							'z-index': 11,
						});

						$items.removeClass('is-active');
						$item07.addClass('is-active');
					},
					onReverseComplete() {
						$('.mobile-slider__nav__container').attr('data-slide', 6);

						queryPush({
							hero: 6,
						}, '/');

						$sliderDots.removeClass('is-active');
						$sliderDots.eq(5).addClass('is-active');

						TweenMax.to($item06, sliderSpeed, {
							'scale': 1,
							'z-index': 11,
						});

						TweenMax.to($item07, sliderSpeed, {
							'scale': 0.9,
							'z-index': 10,
						});

						$items.removeClass('is-active');
						$item06.addClass('is-active');
					},
				})
				.addLabel('item-7')
				.addPause()
				.to($mobileSliderContent, sliderSpeed, {
					x: `-=${itemWidth}`,
					ease: Linear.easeNone,
					force3D: true,
					onComplete() {
						$('.mobile-slider__nav__container').attr('data-slide', 8);

						queryPush({
							hero: 8,
						}, '/');

						$sliderDots.removeClass('is-active');
						$sliderDots.eq(7).addClass('is-active');

						TweenMax.to($item07, sliderSpeed, {
							'scale': 0.9,
							'z-index': 10,
						});

						TweenMax.to($item08, sliderSpeed, {
							'scale': 1,
							'z-index': 11,
						});

						$items.removeClass('is-active');
						$item08.addClass('is-active');
					},
					onReverseComplete() {
						$('.mobile-slider__nav__container').attr('data-slide', 7);

						queryPush({
							hero: 7,
						}, '/');

						$sliderDots.removeClass('is-active');
						$sliderDots.eq(6).addClass('is-active');

						TweenMax.to($item07, sliderSpeed, {
							'scale': 1,
							'z-index': 11,
						});

						TweenMax.to($item08, sliderSpeed, {
							'scale': 0.9,
							'z-index': 10,
						});

						$items.removeClass('is-active');
						$item07.addClass('is-active');
					},
				})
				.addLabel('item-8')
				.addPause()
				.to($mobileSliderContent, sliderSpeed, {
					x: `-=${itemWidth}`,
					ease: Linear.easeNone,
					force3D: true,
					onComplete() {
						$('.mobile-slider__nav__container').attr('data-slide', 9);

						queryPush({
							hero: 9,
						}, '/');

						$sliderDots.removeClass('is-active');
						$sliderDots.eq(8).addClass('is-active');

						TweenMax.to($item08, sliderSpeed, {
							'scale': 0.9,
							'z-index': 10,
						});

						TweenMax.to($item09, sliderSpeed, {
							'scale': 1,
							'z-index': 11,
						});

						$items.removeClass('is-active');
						$item09.addClass('is-active');
					},
					onReverseComplete() {
						$('.mobile-slider__nav__container').attr('data-slide', 8);

						queryPush({
							hero: 8,
						}, '/');

						$sliderDots.removeClass('is-active');
						$sliderDots.eq(7).addClass('is-active');

						TweenMax.to($item08, sliderSpeed, {
							'scale': 1,
							'z-index': 11,
						});

						TweenMax.to($item09, sliderSpeed, {
							'scale': 0.9,
							'z-index': 10,
						});

						$items.removeClass('is-active');
						$item08.addClass('is-active');
					},
				})
				.addLabel('item-9')
				.addPause()
				.to($mobileSliderContent, sliderSpeed, {
					x: `-=${itemWidth}`,
					ease: Linear.easeNone,
					force3D: true,
					onComplete() {
						$('.mobile-slider__nav__container').attr('data-slide', 10);

						queryPush({
							hero: 10,
						}, '/');

						$sliderDots.removeClass('is-active');
						$sliderDots.eq(9).addClass('is-active');

						TweenMax.to($item09, sliderSpeed, {
							'scale': 0.9,
							'z-index': 10,
						});

						TweenMax.to($item10, sliderSpeed, {
							'scale': 1,
							'z-index': 11,
						});

						$items.removeClass('is-active');
						$item10.addClass('is-active');
					},
					onReverseComplete() {
						$('.mobile-slider__nav__container').attr('data-slide', 9);

						queryPush({
							hero: 9,
						}, '/');

						$sliderDots.removeClass('is-active');
						$sliderDots.eq(8).addClass('is-active');

						TweenMax.to($item09, sliderSpeed, {
							'scale': 1,
							'z-index': 11,
						});

						TweenMax.to($item10, sliderSpeed, {
							'scale': 0.9,
							'z-index': 10,
						});

						$items.removeClass('is-active');
						$item09.addClass('is-active');
					},
				})
				.addLabel('item-10')
				.addPause()
				.to($mobileSliderContent, sliderSpeed, {
					x: `-=${itemWidth}`,
					ease: Linear.easeNone,
					force3D: true,
					onComplete() {
						$('.mobile-slider__nav__container').attr('data-slide', 11);

						queryPush({
							hero: 11,
						}, '/');

						$sliderDots.removeClass('is-active');
						$sliderDots.eq(10).addClass('is-active');

						TweenMax.to($item10, sliderSpeed, {
							'scale': 0.9,
							'z-index': 10,
						});

						TweenMax.to($item11, sliderSpeed, {
							'scale': 1,
							'z-index': 11,
						});

						$items.removeClass('is-active');
						$item11.addClass('is-active');
					},
					onReverseComplete() {
						$('.mobile-slider__nav__container').attr('data-slide', 10);

						queryPush({
							hero: 10,
						}, '/');

						$sliderDots.removeClass('is-active');
						$sliderDots.eq(9).addClass('is-active');

						TweenMax.to($item10, sliderSpeed, {
							'scale': 1,
							'z-index': 11,
						});

						TweenMax.to($item11, sliderSpeed, {
							'scale': 0.9,
							'z-index': 10,
						});

						$items.removeClass('is-active');
						$item10.addClass('is-active');
					},
				})
				.addLabel('item-11');

			if (window.shouldScrollToThirdHero) {
				setTimeout(() => {
					mobileHeroSliderTimeline.play();
				}, 1000);
			}
		},
		mobileHideHero(number) {
			if (mobileHideHeroTimeline) {
				mobileHideHeroTimeline.kill();
				mobileHideHeroTimeline = null;
			}

			mobileHideHeroTimeline = new TimelineMax({
				onStart() {
					$html.removeClass('mobile-page-hero ready-to-scroll');
				},
				onComplete() {
					mobileHeroSliderTimeline.seek(0).kill();
					mobileShowHeroTimeline.seek(0).kill();
					$mobileSliderItemButton.off('click');
					animObj.mobileShowInfo(number);
				},
			});

			let $currentHero = $mobileSlider.find('.mobile-slider__content__item').filter(`[data-item=${number}]`);
			let $currentHeroTitle = $currentHero.find('.mobile-slider__content__item__title');
			let $currentHeroCity = $currentHero.find('.mobile-slider__content__item__city');
			let $currentHeroDescription = $currentHero.find('.mobile-slider__content__item__description');
			let $currentHeroButton = $currentHero.find('.mobile-slider__content__item__button');
			let $currentHeroBg = $currentHero.find('.mobile-slider__content__item__bg');
			let $currentHeroFade = $currentHero.find('.mobile-slider__content__item__fade');

			mobileHideHeroTimeline
				.to([$currentHeroBg, $currentHeroFade], 0.5, {
					scale: 6,
					autoAlpha: 0,
				}, 'start')
				.to($sliderDots, 0.3, {
					y: 100,
				}, 'start')
				.to([$currentHeroTitle, $currentHeroCity, $currentHeroDescription], 0.4, {
					y: -10,
					autoAlpha: 0,
				}, 'start')
				.to($currentHeroButton, 0.2, {
					autoAlpha: 0,
				}, 'start')
				.to($sliderItems, 0.2, {
					autoAlpha: 0,
				}, '-=0.5');
		},
		mobileShowInfo(number) {
			if (!number) {
				number = queryParse('object').hero || 1;
			}

			Share._metaUpdateByPageData(pagesData[`hero-${number}`]);

			let $currentInfo = $screenInfo.filter(`[data-item=${number}]`);
			let $infoImage = $currentInfo.find('.screen-info__content__mobile__image');
			let $infoContent = $currentInfo.find('.screen-info__content__mobile__block');
			let $buttonClose = $currentInfo.find('.button-close');
			let mediaElements = [];

			if (mobileShowInfoTimeline) {
				mobileShowInfoTimeline.kill();
				mobileShowInfoTimeline = null;
			}

			mobileShowInfoTimeline = new TimelineMax({
				onStart() {
					$currentInfo.removeClass('is-hidden');
					$html.addClass('page-info-mobile ready-to-scroll');
					$body.addClass('page-info-mobile');
					$mobileSlider.addClass('is-hidden');

					$window.get(0).scrollTo(0, 0);
				},
				onComplete() {
					if (mobileHideHeroTimeline) {
						mobileHideHeroTimeline.seek(0).kill();

						$('.mobile-slider__content__item__title, .mobile-slider__content__item__city,' +
							' .mobile-slider__content__item__description, .mobile-slider__content__item__button')
							.each((i, e) => {
								$(e).removeAttr('style');
							});
					}

					queryPush({
						hero: number,
						name: 'info',
					}, '/');

					// Init mobile video

					// eslint-disable-next-line no-use-before-define
					let currentHeroVideo = mobileHeroVideoInit(
						$currentInfo.find('.mobile-hero-video'),
						$currentInfo.find('.mobile-hero-video__container'),
						parseInt(number, 10),
						`/images/mobile/hero-mobile-video-${number}.png`
					);

					mediaElements.push(currentHeroVideo);

					// Sound elements

					let $soundItems = $currentInfo.find('.sound-item');

					$soundItems.each((i, e) => {
						// eslint-disable-next-line no-use-before-define
						soundItemsInit($(e), `/audio/hero-${number}-sound-${i + 1}.mp3`);
					});

					// Video elements

					let $videoItems = $currentInfo.find('.video-item');

					$videoItems.each((i, e) => {
						// eslint-disable-next-line no-use-before-define
						let videoItem = videoItemsInit($(e), videoList.content[number][i + 1], `/images/video/hero-${number}-video-${i + 1}.jpg`);

						mediaElements.push(videoItem);
					});

					mediaElements.forEach((e) => {
						let that = e;

						that.on('play', () => {
							mediaElements.forEach((mediaElement) => {
								if (that !== mediaElement) {
									TweenMax.to({
										volume: 100,
									}, 1, {
										volume: 0,
										onUpdate() {
											mediaElement.setVolume(this.target.volume);
										},
										onComplete() {
											mediaElement.stop();
										},
									});
								}
							});
						});
					});

					$buttonClose.off('click');
					$buttonClose.on('click', () => {
						TweenMax.to($currentInfo, 0.7, {
							autoAlpha: 0,
							clearProps: 'all',
							onStart() {
								animObj.mobileShowHero(number);
								$window.swipe('destroy');
								$sliderDots.removeClass('is-active');
							},
							onComplete() {
								$currentInfo.addClass('is-hidden');
								$html.removeClass('page-info-mobile');
								$body.removeClass('page-info-mobile');

								mediaElements.forEach((e) => {
									e.stop();
								});
							},
						});
					});

					let checkBottom = _.throttle(() => {
						if ($window.scrollTop() + $window.outerHeight() >= parseInt($currentInfo.outerHeight(), 10)
							&& $html.hasClass('ready-to-scroll')) {
							$window.swipe({
								swipeStatus(event, dir, phase, dis) {
									$currentInfo.css({
										top: -dis,
									});
								},

								swipe(event, dir, dis) {
									if (dis < 50) {
										$currentInfo.animate({
											top: 0,
										});
									} else {
										TweenMax.to($currentInfo, 1, {
											y: -$window.outerHeight(),
											clearProps: 'all',
											onStart() {
												$html.removeClass('ready-to-scroll');
												$window.swipe('destroy');

												let thisName = $screenInfo.not('.is-hidden').data('name');

												ga('send', 'event', 'hero', 'scroll bottom', thisName);
											},
											onComplete() {
												let nextItem = parseInt(number, 10);

												if (nextItem === 11) {
													nextItem = 0;
												}

												$currentInfo.addClass('is-hidden');
												animObj.mobileShowInfo(nextItem + 1);
												$html.removeClass('page-info-mobile');
												$body.removeClass('page-info-mobile');

												mediaElements.forEach((e) => {
													e.stop();
												});
											},
										});
									}
								},
							});
						}
					}, 1000);

					$window.swipe({
						swipeUp() {
							checkBottom();
						},
						threshold: 20,
						allowPageScroll: true,
						preventDefaultEvents: false,
					});

					changePathCounter(location.search);
				},
			});

			mobileShowInfoTimeline
				.from($infoImage, 0.7, {
					autoAlpha: 0,
					y: 80,
					clearProps: 'all',
				})
				.from($infoContent, 0.5, {
					autoAlpha: 0,
					y: 80,
					clearProps: 'all',
				}, '-=0.3')
				.from($buttonClose, 0.5, {
					autoAlpha: 0,
					rotation: 540,
					ease: Linear.easeNone,
					clearProps: 'all',
				}, '-=0.3');
		},
	};

	let introVideoInit = () => {
		introVideo = jwplayer($screenVideo.find('> div').get(0)).setup({
			file: videoList.main,
			image: '/images/main-video.jpg',
			width: '100%',
			height: '100%',
			stretching: 'fill',
			autostart: true,
			controls: false,
			mute: false,
		});

		introVideo.setVolume(100);

		// Intro video skip

		$skipButton.on('click', () => {
			TweenMax.to({
				volume: 100,
			}, 0.3, {
				volume: 0,
				onUpdate() {
					introVideo.setVolume(this.target.volume);
				},
				onComplete() {
					animObj.videoHide(introVideo);
				},
			});
		});

		introVideo.on('complete', () => {
			TweenMax.to({
				volume: introVideo.getVolume(),
			}, 0.5, {
				volume: 0,
				onUpdate() {
					introVideo.setVolume(this.target.volume);
				},
				onComplete() {
					animObj.videoHide(introVideo);
				},
			});

			ga('send', 'event', 'intro', 'finish', 'main page');
		});

		introVideo.on('play', () => {
			if (introVideo.getPosition() === 0) {
				ga('send', 'event', 'intro', 'start', 'main page', {
					nonInteraction: true,
				});
			}
		});

		// Toggle sound video

		let $muteButton = $screenVideo.find('.sound');

		$muteButton.on('click', (event) => {
			let $this = $(event.currentTarget);

			if ($this.hasClass('is-off')) {
				introVideo.setVolume(100);
				$this.removeClass('is-off');
			} else {
				introVideo.setVolume(0);

				$this.addClass('is-off');
			}
		});
	};

	// Router

	let router = _.throttle(() => {
		let query = queryParse('object');

		if (!query.name) {
			query.name = 'video';
		}

		if (query.name === 'video') {
			query.name = 'main';
		}

		$screen.add($parallax).addClass('is-hidden');

		if (location.pathname === '/about') {
			Share._metaUpdateByPageData(pagesData.map);
			window.directEnter = true;
			animObj.aboutShow();

			if ($html.hasClass('is-device-mobile')) {
				$html.css({
					position: 'fixed',
					height: '100vh',
				});

				$body.css({
					overflowY: 'hidden',
				});
			}

			return;
		}

		switch (query.name) {
			case 'video': {
				$('.screen')
					.filter('.screen-video')
					.removeClass('is-hidden');
				$html.addClass('page-video');
				introVideoInit();
				break;
			}

			case 'main': {
				window.directEnter = true;
				Share._metaUpdateByPageData(pagesData.map);

				$('.screen')
					.filter('.screen-main')
					.removeClass('is-hidden');
				$('.parallax').removeClass('is-hidden');

				if ($html.outerWidth() > 1024) {
					$html.addClass('page-main');
					$html.removeClass('ready-to-scroll');
					animObj.mainShow();
				} else {
					$mainPageContentTitle.html('Россия<br> без границ');
					queryPush({
						name: 'main',
					}, '/');

					$html.addClass('mobile-main-page');

					$mainPageContentButton.on('click', () => {
						if ($html.hasClass('mobile-main-page') && $html.hasClass('ready-to-scroll')) {
							animObj.mobileHideMain();
						}
					});

					$window.swipe({
						swipeUp() {
							if ($html.hasClass('mobile-main-page') && $html.hasClass('ready-to-scroll')) {
								animObj.mobileHideMain();
							}
						},
						threshold: 50,
					});
				}

				break;
			}

			case 'map': {
				Share._metaUpdateByPageData(pagesData.map);
				window.directEnter = true;

				if ($html.outerWidth() <= 1024) {
					$mainPageContentTitle.html('Россия<br> без границ');
					queryPush({
						name: 'main',
					}, '/');

					$html.addClass('mobile-main-page');
					$('.screen')
						.filter('.screen-main')
						.removeClass('is-hidden');
					$('.parallax').removeClass('is-hidden');

					$mainPageContentButton.on('click', () => {
						if ($html.hasClass('mobile-main-page') && $html.hasClass('ready-to-scroll')) {
							animObj.mobileHideMain();
						}
					});

					$window.swipe({
						swipeUp() {
							if ($html.hasClass('mobile-main-page') && $html.hasClass('ready-to-scroll')) {
								animObj.mobileHideMain();
							}
						},
						threshold: 50,
					});
				} else {
					$('.screen')
						.filter('.screen-map')
						.removeClass('is-hidden');
					$html.addClass('page-map');
					$('.parallax').removeClass('is-hidden');
					animObj.mapShow();
				}

				break;
			}

			case 'hero': {
				window.directEnter = true;

				if ($window.outerWidth() > 1024) {
					$html.addClass('page-hero');
					TweenMax.to($('.top-menu__item:first-child > .top-menu__item__line').removeClass('is-active'), 1.3, {
						width: '100%',
					});
					animObj.showHero();
				} else {
					animObj.mobileShowHero();
				}

				break;
			}

			case 'info': {
				Share._metaUpdateByPageData(pagesData[`hero-${queryParse('hero')}`]);
				window.directEnter = true;

				if ($html.outerWidth() > 1024) {
					$html.addClass('page-info');
					TweenMax.to($('.top-menu__item:first-child > .top-menu__item__line').removeClass('is-active'), 1.3, {
						width: '100%',
					});
					animObj.showInfo();
				} else {
					animObj.mobileShowInfo();
				}

				break;
			}

			default: {
				break;
			}
		}
	}, 1000, {
		trailing: false,
	});

	$window.on('mousewheel', _.throttle((event) => {
		let delta = event.deltaY;

		if ($html.hasClass('page-video') && $html.hasClass('ready-to-scroll') && delta < 0) {
			TweenMax.to({
				volume: introVideo.getVolume(),
			}, 0.5, {
				volume: 0,
				onUpdate() {
					introVideo.setVolume(this.target.volume);
				},
				onComplete() {
					animObj.videoHide(introVideo);
				},
			});
		}

		if ($html.hasClass('page-main') && $html.hasClass('ready-to-scroll') && delta < 0) {
			animObj.mainHide();

			ga('send', 'event', 'map', 'go to map', 'by scroll');
		}

		if ($html.hasClass('page-map') && $html.hasClass('ready-to-scroll') && delta < 0) {
			animObj.mapHide();

			ga('send', 'event', 'map', 'scroll');
		}
	}, 1000, {
		trailing: false,
	}));

	// Next, prev hero buttons

	$nextButton.on('click', () => {
		animObj.switchHeroNext();
	});

	$prevButton.on('click', () => {
		animObj.switchHeroPrev();
	});

	// Map city button

	$mapPageRouteItems.on('click', (event) => {
		let $this = $(event.currentTarget);

		if ($html.hasClass('ready-to-scroll')) {
			animObj.mapHide($this);
		}
	});

	// Map finger button

	$mapPageFinger.on('click', () => {
		if ($html.hasClass('ready-to-scroll')) {
			animObj.mapHide();
		}
	});

	// Hero map button

	$heroMiniMap.on('mouseenter', () => {
		TweenMax.to([
			$heroPageBg,
			$heroPageCoordinates,
			$heroPageContentTitle,
			$heroPageContentDescription,
			$heroPageContentText,
			$heroBigPhone,
			$heroPageContentCity,
			$screenPageInfoBg,
			$screenInfoContentWrap,
		], 0.5, {
			x: 150,
		});
	}).on('mouseleave', () => {
		TweenMax.to([
			$heroPageBg,
			$heroPageCoordinates,
			$heroPageContentTitle,
			$heroPageContentDescription,
			$heroPageContentText,
			$heroBigPhone,
			$heroPageContentCity,
			$screenPageInfoBg,
			$screenInfoContentWrap,
		], 0.5, {
			x: 0,
		});
	});

	// Preload images

	let imageSrc = [
		'/images/big-map.jpg',
		'/images/hero-bg-1.png',
		'/images/hero-bg-1@2x.jpg',
		'/images/hero-bg-2.jpg',
		'/images/hero-bg-2@2x.jpg',
		'/images/hero-bg-3.jpg',
		'/images/hero-bg-3@2x.jpg',
		'/images/hero-bg-4.jpg',
		'/images/hero-bg-4@2x.jpg',
		'/images/hero-bg-5.jpg',
		'/images/hero-bg-5@2x.jpg',
		'/images/hero-bg-6.jpg',
		'/images/hero-bg-6@2x.jpg',
		'/images/hero-bg-7.jpg',
		'/images/hero-bg-7@2x.jpg',
		'/images/hero-bg-8.jpg',
		'/images/hero-bg-8@2x.jpg',
		'/images/hero-bg-9.jpg',
		'/images/hero-bg-9@2x.jpg',
		'/images/hero-bg-10.jpg',
		'/images/hero-bg-10@2x.jpg',
		'/images/hero-bg-11.jpg',
		'/images/hero-bg-11@2x.jpg',
		'/images/clouds/cloud.png',
		'/images/clouds/cloud@2x.png',
		'/images/clouds/cloud2.png',
		'/images/clouds/cloud2@2x.png',
		'/images/clouds/cloud3.png',
		'/images/clouds/cloud3@2x.png',
		'/images/clouds/cloud4.png',
		'/images/clouds/cloud4@2x.png',
		'/images/info-bg.png',
	];

	let imagePreload = (arr) => {
		arr.forEach((e) => {
			let image = new Image();

			image.src = e;
		});
	};

	if ($window.outerWidth() > 1024) {
		imagePreload(imageSrc);
	}

	$window.on('resize', _.debounce(updatePointer, 300));
	updatePointer();

	// Play simple audio

	let checkAudio = () => {
		if ($soundButton.hasClass('is-off')) {
			if (simpleSound) {
				TweenMax.to({
					volume: simpleSound.getVolume(),
				}, 1.2, {
					volume: 0,
					ease: Linear.easeNone,
					onUpdate() {
						simpleSound.setVolume(this.target.volume);
					},
				});
			}
		} else if (simpleSound) {
			TweenMax.to({
				volume: simpleSound.getVolume(),
			}, 1.2, {
				volume: 100,
				ease: Linear.easeNone,
				onUpdate() {
					simpleSound.setVolume(this.target.volume);
				},
			});
		}
	};

	setTimeout(() => {
		if (!$html.hasClass('page-video') && $html.outerWidth() > 1024) {
			audioInit();
		}
	}, 2000);

	// Show mobile hero video

	let mobileHeroVideoInit = (el, container, path, image) => {
		let videoContainer = container.attr('id', `id-hero-video-${Date.now()}`).get(0);

		let heroVideo = jwplayer(videoContainer).setup({
			file: videoList[path],
			image,
			width: '100%',
			height: '100%',
			stretching: 'fill',
			autostart: false,
			controls: true,
			mute: false,
		});

		let $playButton = el.find('.button-play--mobile');
		let $pauseButton = el.find('.button-pause--mobile');

		$playButton.on('click', (event) => {
			let $this = $(event.currentTarget);

			heroVideo.setVolume(100);
			heroVideo.play(true);
			$this.addClass('is-hidden');
			$pauseButton.removeClass('is-hidden');
		});

		$pauseButton.on('click', (event) => {
			let $this = $(event.currentTarget);

			heroVideo.setVolume(0);
			heroVideo.pause(true);
			$this.addClass('is-hidden');
			$playButton.removeClass('is-hidden');
		});

		heroVideo.onDisplayClick(() => {
			if (el.hasClass('is-play')) {
				heroVideo.pause(true);
			} else {
				heroVideo.setVolume(100);
				heroVideo.play(true);
			}
		});

		heroVideo.on('play', () => {
			el.addClass('is-play');
			$playButton.addClass('is-hidden');
			$pauseButton.removeClass('is-hidden');
		});

		heroVideo.on('pause complete stop idle', () => {
			el.removeClass('is-play');
			$playButton.removeClass('is-hidden');
			$pauseButton.addClass('is-hidden');
		});

		heroVideo.on('play', () => {
			if (heroVideo.getPosition() === 0) {
				let thisName = $screenInfo.not('.is-hidden').data('name');

				ga('send', 'event', 'intro', 'start', thisName);
			}
		});

		heroVideo.on('complete', () => {
			let thisName = $screenInfo.not('.is-hidden').data('name');

			ga('send', 'event', 'intro', 'finish', thisName);
		});

		return heroVideo;
	};

	// Sound items init

	let soundItemsInit = ($el, path) => {
		let $soundContainer = $el.find('.sound-item__container');

		$soundContainer.attr('id', `id-audio-${Date.now()}`);

		let soundItem = jwplayer($soundContainer.get(0)).setup({
			file: path,
			width: '0',
			height: '0',
			stretching: 'fill',
			autostart: false,
			controls: false,
			mute: false,
			repeat: false,
			preload: 'auto',
		});

		let thisName = $el.parents('.screen-info').data('name');
		let thisNumber = $el.data('item');

		$el.find('.sound-item__button.button-play').on('click', (event) => {
			let $this = $(event.currentTarget);

			$this.parents('.sound-item').addClass('is-play');

			soundItem.play();
			TweenMax.to({
				volume: 0,
			}, 1, {
				volume: 100,
				onUpdate() {
					soundItem.setVolume(this.target.volume);
				},
			});

			ga('send', 'event', 'hero', 'inner audio play', `${thisName} ${thisNumber}`);
		});

		$el.find('.sound-item__button.button-pause').on('click', (event) => {
			let $this = $(event.currentTarget);

			TweenMax.to({
				volume: 100,
			}, 1, {
				volume: 0,
				onUpdate() {
					soundItem.setVolume(this.target.volume);
				},
				onComplete() {
					soundItem.pause();
					$this.parents('.sound-item').removeClass('is-play');
				},
			});
		});

		soundItem.on('play', () => {
			if (!$soundButton.hasClass('is-off')) {
				if (simpleSound) {
					TweenMax.to({
						volume: simpleSound.getVolume(),
					}, 1, {
						volume: 50,
						ease: Linear.easeNone,
						onUpdate() {
							simpleSound.setVolume(this.target.volume);
						},
					});
				}
			}

			if (soundItem.getPosition() === 0) {
				ga('send', 'event', 'inner audio', 'start', `${thisName} ${thisNumber}`);
			}
		});

		soundItem.on('complete', () => {
			if (!$soundButton.hasClass('is-off')) {
				if (simpleSound) {
					TweenMax.to({
						volume: simpleSound.getVolume(),
					}, 1, {
						volume: 100,
						ease: Linear.easeNone,
						onUpdate() {
							simpleSound.setVolume(this.target.volume);
						},
					});
				}
			}

			ga('send', 'event', 'inner audio', 'finish', `${thisName} ${thisNumber}`);
		});

		soundItem.on('pause', () => {
			if (!$soundButton.hasClass('is-off')) {
				if (simpleSound) {
					TweenMax.to({
						volume: simpleSound.getVolume(),
					}, 1, {
						volume: 100,
						ease: Linear.easeNone,
						onUpdate() {
							simpleSound.setVolume(this.target.volume);
						},
					});
				}
			}
		});

		let $audioLines = $el.find('.sound-item__line__item--02');
		let $audioTimeMinutes = $el.find('.sound-item__time__minutes');
		let $audioTimeSeconds = $el.find('.sound-item__time__seconds');

		// Init sound time

		let soundItemDuration = $el.data('duration');

		soundItem.on('ready', () => {
			let duration = soundItem.getDuration() || parseInt(soundItemDuration, 10);
			let position = soundItem.getPosition();

			let minutes = Math.floor(duration / 60);
			let seconds = Math.floor(duration - minutes * 60);
			let calcSeconds = parseInt(seconds - position, 10);

			if (minutes >= 10) {
				$audioTimeMinutes.text(minutes);
			} else {
				$audioTimeMinutes.text(`0${minutes}`);
			}

			if (calcSeconds >= 10) {
				$audioTimeSeconds.text(calcSeconds);
			} else {
				$audioTimeSeconds.text(`0${calcSeconds}`);
			}
		});

		soundItem.on('time idle', () => {
			let duration = soundItem.getDuration();
			let position = soundItem.getPosition();
			let percentage = Math.round(position / (duration / 100));

			$audioLines.css({
				width: `${percentage}%`,
			});

			let minutes = Math.floor(duration / 60);
			let seconds = Math.floor(duration - minutes * 60);

			let calcSeconds = parseInt(seconds - position, 10);

			if (minutes >= 10) {
				$audioTimeMinutes.text(minutes);
			} else {
				$audioTimeMinutes.text(`0${minutes}`);
			}

			if (calcSeconds >= 10) {
				$audioTimeSeconds.text(calcSeconds);
			} else {
				$audioTimeSeconds.text(`0${calcSeconds}`);
			}
		});

		soundItem.on('idle', () => {
			$el.removeClass('is-play');
		});

		return soundItem;
	};

	// Video items init

	let videoItemsInit = ($el, path, pathimg) => {
		let controlsVideo = false;

		if ($html.outerWidth() <= 1024) {
			controlsVideo = true;
		}

		let $videoContainer = $el.find('.video-item__container');

		$videoContainer.attr('id', `id-video-${Date.now()}`);

		let videoItem = jwplayer($videoContainer.get(0)).setup({
			file: path,
			image: pathimg,
			width: '100%',
			height: '100%',
			stretching: 'fill',
			autostart: false,
			controls: controlsVideo,
			mute: false,
			repeat: false,
			preload: 'auto',
		});

		let thisName = $el.parents('.screen-info').data('name');
		let thisNumber = $el.data('item');

		$el.find('.button-play').on('click', (event) => {
			let $this = $(event.currentTarget);

			videoItem.play();
			TweenMax.to({
				volume: 0,
			}, 1, {
				volume: 100,
				onUpdate() {
					videoItem.setVolume(this.target.volume);
				},
			});

			$this.parents('.video-item').addClass('is-play');
			ga('send', 'event', 'hero', 'inner video play', `${thisName}  ${thisNumber}`);
		});

		$el.find('.button-pause').on('click', (event) => {
			let $this = $(event.currentTarget);

			TweenMax.to({
				volume: 100,
			}, 1, {
				volume: 0,
				onUpdate() {
					videoItem.setVolume(this.target.volume);
				},
				onComplete() {
					videoItem.pause(true);
					$this.parents('.video-item').removeClass('is-play');
				},
			});
		});

		videoItem.on('play', () => {
			if (!$soundButton.hasClass('is-off')) {
				if (simpleSound) {
					TweenMax.to({
						volume: simpleSound.getVolume(),
					}, 1, {
						volume: 50,
						onUpdate() {
							simpleSound.setVolume(this.target.volume);
						},
					});
				}
			}

			if (videoItem.getPosition() === 0) {
				ga('send', 'event', 'inner video', 'start', `${thisName}  ${thisNumber}`);
			}
		});

		videoItem.on('complete', () => {
			if (!$soundButton.hasClass('is-off')) {
				if (simpleSound) {
					TweenMax.to({
						volume: simpleSound.getVolume(),
					}, 1, {
						volume: 100,
						ease: Linear.easeNone,
						onUpdate() {
							simpleSound.setVolume(this.target.volume);
						},
					});
				}
			}

			ga('send', 'event', 'inner video', 'finish', `${thisName}  ${thisNumber}`);
		});

		videoItem.on('pause', () => {
			if (!$soundButton.hasClass('is-off')) {
				if (simpleSound) {
					TweenMax.to({
						volume: simpleSound.getVolume(),
					}, 1, {
						volume: 100,
						onUpdate() {
							simpleSound.setVolume(this.target.volume);
						},
					});
				}
			}
		});

		videoItem.on('idle', () => {
			$el.removeClass('is-play');
		});

		if ($html.outerWidth() <= 1024) {
			videoItem.onDisplayClick(() => {
				videoItem.play();
				videoItem.setVolume(100);

				$el.toggleClass('is-play');
			});
		}

		return videoItem;
	};

	// Router init

	router();

	// Mobile Popup

	lightbox.option({
		fixedNavigation: false,
	});

	setTimeout(() => {
		$('.lb-dataContainer').prependTo('.lb-outerContainer');

		$html.add($('.lb-container')).on('click', () => {
			$('.lb-close').trigger('click');
		});
	}, 1000);

	if ($html.outerWidth() <= 1024) {
		$('a[data-lightbox]').find('> img').unwrap();
	}

	// ------Reload page on back button-----

	$window.on('popstate', (event) => {
		if ($html.hasClass('is-browser-safari')) {
			if (event.state) {
				location.reload(true);
			}
		} else {
			location.reload(true);
		}
	});

	// ------Counters------

	$skipButton.on('click', () => {
		ga('send', 'event', 'main page', 'ignore intro');
	});

	$('.button-eye').on('click', () => {
		ga('send', 'event', 'map', 'go to map', 'by button');
	});

	$mapPageRouteItems.on('click', (event) => {
		let $this = $(event.currentTarget);
		let thisName = $this.data('name');

		ga('send', 'event', 'map', 'label', thisName);
	});

	$mapPageFinger.on('click', () => {
		ga('send', 'event', 'map', 'scroll');
	});

	$screenHero.find('.big-phone__button').on('click', (event) => {
		let $this = $(event.currentTarget);
		let thisName = $this.parents('.screen-hero').data('name');

		ga('send', 'event', 'hero', 'intro by play', thisName);
	});

	$heroMiniMap.on('click', () => {
		ga('send', 'event', 'hero', 'go to map');
	});

	window.menuMapLocked = false;
	window.menuAboutLocked = false;

	if (innerWidth > 1024) {
		$('.screen-hero .mini-map').on('click', (e) => {
			e.preventDefault();
			animObj.hideHero(null, null, true);
		});

		$('.screen-info .mini-map').on('click', (e) => {
			e.preventDefault();
			animObj.hideInfo(null, true);
		});

		$('.top-menu__item[href="/?name=map"]').on('click', (e) => {
			let query = queryParse('object');

			if (location.pathname === '/about') {
				e.preventDefault();
				animObj.mapShowAfterAbout();

				return;
			}

			switch (query.name) {
				case 'main':
					e.preventDefault();

					if (!window.canGoToMap || window.menuMapLocked) {
						return;
					}

					animObj.mainHide();
					break;

				case 'hero':
					e.preventDefault();

					if (!window.canGoToMap || window.menuMapLocked) {
						return;
					}

					animObj.hideHero(null, null, true);
					break;

				case 'info':
					e.preventDefault();

					if (!window.canGoToMap || window.menuMapLocked) {
						return;
					}

					animObj.hideInfo(null, true);
					break;
				// no default
			}
		});

		$('.top-menu__item[href="/about"]').on('click', (e) => {
			let query = queryParse('object');

			switch (query.name) {
				case 'main':
					e.preventDefault();

					if (!window.canGoToAbout || window.menuAboutLocked) {
						return;
					}

					animObj.mainHide(true);
					break;
				case 'map':
					e.preventDefault();

					if (!window.canGoToAbout || window.menuAboutLocked) {
						return;
					}

					animObj.mapHide(null, true);
					break;
				case 'hero':
					e.preventDefault();

					if (!window.canGoToAbout || window.menuAboutLocked) {
						return;
					}

					animObj.hideHero(null, true);
					break;

				case 'info':
					e.preventDefault();

					if (!window.canGoToAbout || window.menuAboutLocked) {
						return;
					}

					animObj.hideInfo(true);
					break;

				// no default
			}
		});
	}
}

if ($(document.documentElement).hasClass('page-about')) {
	audioInit();

	const $aboutContent = $('.screen--about__content');

	let titlesTimeline = new TimelineMax({
		delay: 2,
	});

	let titlesTween = TweenMax.fromTo($aboutContent, ($aboutContent.outerHeight() + $html.outerHeight()) / 100, {
		y: $html.outerHeight() / 2 - 110,
		ease: Linear.easeNone,
		force3D: true,
	}, {
		y: -$aboutContent.outerHeight() + $html.outerHeight() / 2,
		ease: Linear.easeNone,
		force3D: true,
	});

	titlesTimeline.add(titlesTween);

	let changeTitles = _.once(() => {
		titlesTimeline.remove(titlesTimeline.getChildren());

		titlesTimeline.fromTo($aboutContent, $aboutContent.outerHeight() / 100, {
			y: 0,
			ease: Linear.easeNone,
			force3D: true,
		}, {
			y: -$aboutContent.outerHeight() + $html.outerHeight() - 150,
			ease: Linear.easeNone,
			force3D: true,
		});
	});

	if ($html.outerWidth() <= 1024) {
		$window.swipe({
			swipeStatus(event, phase, dir) {
				titlesTimeline.pause();

				let progress = titlesTimeline.progress();
				let progressStep = 0.0065;
				let newTime;

				if (progress >= 0.2) {
					changeTitles();
				}

				if (dir === 'down') {
					progressStep = -progressStep;
				}

				newTime = progress + progressStep;

				if (newTime < 0) {
					newTime = 0;
				}

				newTime = progress + progressStep;

				if (newTime < 0) {
					newTime = 0;
				}

				titlesTimeline.progress(newTime);
			},
			allowPageScroll: 'none',
		});
	} else {
		$window.on('mousewheel', _.throttle((event) => {
			event.preventDefault();

			titlesTimeline.pause();

			let progress = titlesTimeline.progress();
			let progressStep;
			let newTime;

			if ($html.hasClass('is-browser-safari')) {
				progressStep = 0.01;
			} else {
				progressStep = 0.03;
			}

			if (progress >= 0.2) {
				changeTitles();
			}

			if (event.deltaY > 0) {
				progressStep = -progressStep;
			}

			newTime = progress + progressStep;

			if (newTime < 0) {
				newTime = 0;
			}

			titlesTimeline.progress(newTime);
		}, 25));
	}

	// Parallax

	$parallax.removeClass('is-hidden');
	animateClouds();

	// Active menu item

	TweenMax.to($('.top-menu__item:last-child > .top-menu__item__line').removeClass('is-active'), 1.3, {
		width: '100%',
	});
}

if ($(document.documentElement).hasClass('page-competition')) {
	audioInit();

	$('.top-menu').children().eq(1).addClass('is-active');
}

$('.screen__card.card').on('click', () => {
	window
		.open('http://www.samsung.com/ru/smartphones/galaxy-s8/?cid=ru_spojects_rbc_s8launch_20171307', '_blank')
		.focus();
});

/* eslint-disable no-underscore-dangle,no-use-before-define,max-len */
/* global checkAudio, changePathCounter, queryParse, queryPush, Share, pagesData, lightbox, Dropzone, Parallax, clearoldphoto: true, checkMail */

if ($(document.documentElement).hasClass('page-competition')) {
	// Global Variables
	let $window = $(window);
	let $html = $(document.documentElement);
	let $body = $(document.body);

	// TAB
	let lockTab = false;
	let $btns = $('.button-tabs__btn');

	// Tab form vars
	let lockForm = false;
	let $tabFormContent = $('.tab-box#tab-form');

	// Tab gallery vars
	let $tabGalleryContent = $('.tab-box#tab-gallery');

	// GALLERY
	let $gallery = $('#competition-gallery');
	let $morephoto = $('#more-photo');

	// LIKE BTN
	let lockicolike = false;

	// PARALLAX
	let parallax;

	let photoid;
	let oldphoto = [];

	// eslint-disable-next-line func-names
	$btns.on('click', function (event) {
		if (lockTab) {
			return false;
		}

		let $btn = $(this);

		if (!$btn.hasClass('is-active')) {
			if ($btn.attr('href') === '#tab-form') {
				animTabObj.tabGalleryHide();
			} else {
				animTabObj.tabFormHide($btn.data('galleryurl'));
			}

			$btns.removeClass('is-active');
			$btn.addClass('is-active');
		}

		if (event.which) {
			let $this = $(event.currentTarget);
			let thisName = $this.data('name');

			ga('send', 'event', 'competition', 'tabs', thisName);
		}

		return false;
	});

	let animTabObj = {
		tabFormShow() {
			let showTabFormTimeline = new TimelineMax({
				onStart() {

				},
				onComplete() {
					lockTab = false;
				},
				ease: Linear.easeNone,
			});

			showTabFormTimeline
				.set($tabFormContent, {
					display: 'block',
				})
				.to($tabFormContent, 0.2, {
					y: 0,
					autoAlpha: 1,
				});

			ga('send', 'event', 'competition', 'form', 'show', {
				nonInteraction: true,
			});

			$(document.body).attr('data-tab', 'form');
		},
		tabFormHide(galleryurl) {
			let tabFormHideTimeline = new TimelineMax({
				onStart() {
					lockTab = true;
				},
				onComplete() {
					animTabObj.tabGalleryShow(galleryurl);
				},
			});

			if ($('body').hasClass('file-upload')) {
				tabFormHideTimeline
					.to($tabFormContent, 0.3, {
						y: -30,
						autoAlpha: 0,
					})
					.set($tabFormContent, {
						display: 'none',
					});
			} else {
				tabFormHideTimeline
					.to($tabFormContent, 0.3, {
						y: -30,
						autoAlpha: 0,
					})
					.set($tabFormContent, {
						display: 'none',
					});
			}
		},
		tabGalleryShow(galleryurl) {
			let tabGalleryShowTimeline = new TimelineMax({
				onStart() {

				},
				onComplete() {
					lockTab = false;

					if (!$('body').hasClass('gallery-ready')) {
						createGallery(galleryurl);
					} else {
						animTabObj.showGallery();
					}
				},
			});

			tabGalleryShowTimeline
				.to($tabGalleryContent, 0.2, {
					autoAlpha: 1,
				});

			$(document.body).attr('data-tab', 'gallery');
		},
		tabGalleryHide() {
			animTabObj.hideGallery();

			let tabGalleryHideTimeline = new TimelineMax({
				onStart() {
					lockTab = true;
				},
				onComplete() {
					animTabObj.tabFormShow();
				},
			});

			tabGalleryHideTimeline
				.to($tabGalleryContent, 0.2, {
					autoAlpha: 0,
				});
		},
		showGallery() {
			let showGalleryHolderTimeline = new TimelineMax({
				onStart() {
					// lockTab = true;
				},
				onComplete() {
					router();
				},
				ease: Linear.easeNone,
			});

			showGalleryHolderTimeline
				.set($gallery, {
					clearProps: 'all',
				})
				.from($gallery, 0.5, {
					scale: 0,
					ease: Elastic.easeOut.config(1, 0.4),
				});
		},
		hideGallery() {
			let showGalleryHolderTimeline = new TimelineMax({
				onStart() {

				},
				onComplete() {

				},
				ease: Linear.easeNone,
			});

			showGalleryHolderTimeline
				.set($gallery, {
					clearProps: 'all',
				})
				.to($gallery, 0.4, {
					scale: 0,
					ease: Power1.easeIn,
				});
		},

	};

	// FILE UPLOAD

	Dropzone.autoDiscover = false;
	let filenameid = '';

	// eslint-disable-next-line no-unused-vars
	let myDropzone = new Dropzone('#mydropzone', {
		clickable: '.dropzone-wrapper',
		// backend
		url: '/upload.php', // ###Debug
		// backend
		maxFiles: 1,
		paramName: 'file',
		thumbnailWidth: null,
		thumbnailHeight: null,
		acceptedFiles: 'image/*',
		dictDefaultMessage: 'Выберите фото<span class="is-hidden-mobile"><br />или перетащите его сюда</span> <br /><svg class="dz-upload"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/images/sprites.svg#upload"></use></svg>',
		addRemoveLinks: true,
		dictRemoveFile: 'Выбрать другое фото',
		init() {
			// eslint-disable-next-line func-names
			this.on('maxfilesexceeded', function (file) {
				this.removeAllFiles();
				this.addFile(file);
			});
			this.on('sending', (file, xhr, formData) => {
				filenameid = `filenameid${Date.now()}`;
				formData.append('filenameid', filenameid);

				ga('send', 'event', 'competition', 'form', 'load image');
			});
			this.on('error', () => {
				filenameid = '';
			});
			// backend
			this.on('success', (file, response) => {
				response = JSON.parse(response);

				if (response.success) {
					filenameid = response.id;
				} else {
					filenameid = '';
				}
			});
			// backend;
		},
	});

	// SEND DATA FORM

	// eslint-disable-next-line func-names
	$('form[name="dataForm"]').submit(function () {
		let hasError = false;

		if (!lockForm) {
			let $form = $(this);

			/* ###debug: remove line when add PHP upload page, this emulate SUCCESS UPLOADING IMG*/
			// backend
			// filenameid = "filenameid" + Date.now();
			// backend

			// check fields
			if (filenameid === '') {
				hasError = true;
				$('.dropzone').addClass('is-fielderror');
			} else {
				$('.dropzone').removeClass('is-fielderror');
			}

			let $field = $form.find('input[name="name"]');

			if ($.trim($field.val()) === '') {
				hasError = true;
				$field.addClass('is-fielderror');
			} else {
				$field.removeClass('is-fielderror');
			}

			$field = $form.find('input[name="email"]');
			if (!checkMail($.trim($field.val()))) {
				hasError = true;
				$field.addClass('is-fielderror');
			} else {
				$field.removeClass('is-fielderror');
			}

			$field = $form.find('input[name="iagree"]');
			if (!$field.prop('checked')) {
				hasError = true;
				$field.next('.custom-checkbox__decor').addClass('is-fielderror');
			} else {
				$field.next('.custom-checkbox__decor').removeClass('is-fielderror');
			}

			if (!hasError) {
				lockForm = true;

				$.ajax({
					type: 'GET',
					url: $form.attr('action'),
					// backend
					dataType: 'json',
					// backend
					data: `${$form.serialize()}&filenameid=${filenameid}`,
					success: function success(response) {
						// backend
						// response = dataFormDATA;

						if (response.success) {
							URL = response.url;
							IMG_PATH = response.img_path;
							$('#alreadysend').addClass('is-hidden');

							showPhoto();

							ga('send', 'event', 'competition', 'form', 'success');
						} else {
							$('#alreadysend').removeClass('is-hidden');
						}

						/*
						 if (response.alreadysend) {

						 $('#alreadysend').removeClass('is-hidden');
						 } else {

						 $('#alreadysend').addClass('is-hidden');

						 showPhoto();

						 ga("send", "event", "competition", "form", "success");
						 }
						 */
						// backend

						lockForm = false;
					},
					error() {
						lockForm = false;
					},
				});
			}
		}

		return false;
	});

	// SHOW PHOTO

	let URL = '';
	let IMG_PATH = '';

	// DESC = '';

	// eslint-disable-next-line no-inner-declarations
	function showPhoto() {
		// backend
		$('img#competition-photo').attr('src', IMG_PATH);
		// backend

		$('.screen--competition__step#step-1').fadeOut('fast', () => {
			Share._metaUpdateByPageData({
				url: URL,
				title: '',
				description: '',
				image: IMG_PATH,
			});

			$('.screen--competition__step#step-2').fadeIn('fast');
			$('body').addClass('file-upload').removeClass('gallery-ready');

			oldphoto = [];

			/*
			$.ajax({
				type: "GET",
				url: uploadedphotourl,
				data: {
					'filenameid': filenameid
				},
				success: function success(response) {

					response = showPhotoDATA; //###Debug

					URL = response.URL;
					//TITLE = response.TITLE;
					IMG_PATH = response.IMG_PATH;
					//DESC = response.DESC;

					Share._metaUpdateByPageData({
						url: URL,
						title: '',
						description: '',
						image: IMG_PATH
					});

					$('img#competition-photo').attr('src', IMG_PATH);

					$('.screen--competition__step#step-2').fadeIn('fast');
					$('body').addClass('file-upload').removeClass('gallery-ready');

					oldphoto = [];
				},
				error: function error() {
				}
			});
			*/
		});
	}

	// GALLERY

	// eslint-disable-next-line no-shadow,no-inner-declarations
	function createGallery(url, oldphoto) {
		// backend
		url = '/get_photos.php';
		// backend

		$.ajax({
			// backend
			type: 'POST',
			url,
			dataType: 'json',
			// backend
			data: {
				oldphoto,
				photoid2show: photoid,
			},
			success(response) {
				// create gallery markup

				if (response.clearoldphoto) {
					clearoldphoto = true;
				}

				/*
				if (response.clearoldphoto) {
					//oldphoto.length = 0;
					//oldphoto.pop();
					oldphoto = [];
				}
				*/

				if ($gallery.hasClass('slick-initialized')) {
					$gallery.slick('unslick');
				}

				$gallery.html('');

				let depth = 0;
				let index = 0;

				$.each(response.photos, (key, photo) => {
					let {
						id, title, thumb, large, likes, likedisable,
					} = photo;

					// backend
					let likedisableclass = likedisable ? 'is-like' : '';
					// backend

					let item = `\n\t\t\t\t\t\t<div class="competition-gallery__item competition-gallery-item is-displayed is-displayed-${index++}" data-id="${id}" data-depth="${depth}">\n\t\t\t\t\t\t\t<div class="competition-gallery-item__thumb" data-counter="${key}">\n\t\t\t\t\t\t\t\t<img src="${thumb}" alt="${title}" />\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="competition-gallery-item__large">\n\t\t\t\t\t\t\t\t<img class="competition-gallery-item__photo" src="${large}" alt="${title}" />\n\t\t\t\t\t\t\t\t<div class="competition-gallery-item__title">${title}</div>\n\t\t\t\t\t\t\t\t<div class="competition-gallery-item__like">\n\t\t\t\t\t\t\t\t\t<svg class="competition-gallery-item__like--ico ${likedisableclass}" width="34" height="28" viewBox="0 0 34 28"><path fill="none" stroke="#0036ff" stroke-miterlimit="50" stroke-width="2" d="M956.43 2435.52l-12.16 12.16c-.72.72-1.8.72-2.52 0l-12.16-12.16a8.61 8.61 0 0 1-.63-11.62 8.35 8.35 0 0 1 12.16-.45l1.8 1.71 1.81-1.71a8.26 8.26 0 0 1 12.15.45 8.4 8.4 0 0 1-.45 11.62z" clip-path="url(&quot;#a&quot;)" transform="translate(-926 -2421)"/></svg>\n\t\t\t\t\t\t\t\t\t<div class="competition-gallery-item__like--counter">\u0433\u043E\u043B\u043E\u0441\u043E\u0432: <span>${likes}</span></div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t`;

					depth += 0.2;

					$gallery.append(item);
				});

				// more photo btn
				if (response.morephoto) {
					$morephoto.removeClass('is-hidden').attr('href', response.morephoto);
				} else {
					$morephoto.addClass('is-hidden').attr('href', '#');
				}

				if ($html.outerWidth() > 375) {
					// desktop

					$body.removeClass('gallery-mobile');

					// Parallax new
					let scene = document.getElementById('competition-gallery');

					parallax = new Parallax(scene, {
						relativeInput: true,
						clipRelativeInput: false,
						hoverOnly: true,
						// inputElement: document.getElementById('competition-gallery'),
						calibrateX: true,
						calibrateY: true,
						invertX: false,
						invertY: true,
						limitX: false,
						limitY: 10,
						scalarX: 2,
						scalarY: 2,
						frictionX: 0.2,
						frictionY: 0.2,
						originX: 0.0,
						originY: 1.0,
						precision: 1,
						pointerEvents: false,
						onReady() {
						},
					});
				} else {
					// mobile

					$body.addClass('gallery-mobile');

					// TODO:

					// + var 1
					// create dot pager
					// sync when big slider update

					// var 2
					// create dot pager slider
					// sync sliders: dot pagers + big slider

					// $body.after()

					// create gallery - pager
					$gallery.on('init', (e, slick) => {
						slick.$dots.wrap('<div class="slick-dots-wrapper"/>');
					});

					$gallery.on('beforeChange', (e, slick, currentSlide, nextSlide) => {
						slick.$dots.children().removeClass('is-small');
						slick.$dots.children().eq(Math.max(0, Math.min(nextSlide - 2, slick.slideCount - 5))).addClass('is-small');
						slick.$dots.children().eq(Math.max(4, Math.min(nextSlide + 2, slick.slideCount - 1))).addClass('is-small');

						TweenMax.set(slick.$dots, {
							x: `${Math.max(0, Math.min(nextSlide - 2, slick.slideCount - 5)) * -20}%`,
						});
					});

					$gallery.on('afterChange', () => {
						// set photo url
						let id = $('.slick-active').data('id');

						queryPush({
							name: 'photo',
							id,
						});
					});

					// create slick gallery
					$gallery.slick({
						arrows: false,
						dots: true,
					});

					if (photoid) {
						let slide = $(`.slick-slide[data-id="${photoid}"]`).data('slick-index');

						$gallery.slick('slickGoTo', slide, true);
					}
				}

				// show intro gallery effect
				animTabObj.showGallery();

				$body.addClass('gallery-ready');
			},
			error() {

			},
		});
	}

	// GALLERY ITEM

	// open
	// eslint-disable-next-line func-names
	$gallery.on('click', '.competition-gallery-item__thumb img', function () {
		if (!$body.hasClass('gallery-mobile')) {
			let id = $(this).parents('.competition-gallery-item').data('id');

			openGallery(id);

			ga('send', 'event', 'competition', 'photo show', id);
		}
	});

	// rotate by scroll next/prev photo
	$window.on('mousewheel', _.throttle((event) => {
		// event.preventDefault();

		if (!$body.hasClass('gallery-mobile')) {
			if ($html.hasClass('page-competition') && $body.hasClass('gallery-open')) {
				if (event.deltaY < 0) {
					// down
					showGalleryNextPhoto('next');
				} else {
					// up
					showGalleryNextPhoto('prev');
				}
			}
		}
	}, 10));

	// close
	// eslint-disable-next-line func-names
	$body.on('click', function (e) {
		if (!$body.hasClass('gallery-mobile')) {
			if ($(this).hasClass('gallery-open')
				&& !$(e.target).is('.social__item')
				&& !$(e.target).is('.social__item *')
				&& !$(e.target).is('.screen__sound')
				&& !$(e.target).is('.screen__sound *')) {
				closeGallery();
			}
		}
	});

	// close by Esc
	$body.keyup((e) => {
		if (e.keyCode === 27 && $body.hasClass('gallery-open') && !$body.hasClass('gallery-mobile')) {
			closeGallery();
		}
	});

	// open gallery
	// eslint-disable-next-line no-inner-declarations
	function openGallery(id) {
		// hide tabs & blur thumbs
		$btns.fadeOut();
		tweenBlur('.competition-gallery-item__thumb', 0, 10);

		$gallery.find(`.competition-gallery-item[data-id="${id}"] .competition-gallery-item__large`).addClass('new');

		$morephoto.fadeOut();

		showGalleryPhoto();
	}

	// close gallery
	// eslint-disable-next-line no-inner-declarations
	function closeGallery() {
		photoid = undefined;

		$body.removeClass('gallery-open');
		setTimeout(() => {
			$body.removeClass('gallery-lock');
		}, 250);

		// show tabs & unblur thumbs
		$btns.fadeIn();
		tweenBlur('.competition-gallery-item__thumb', 10, 0);

		let $el = $gallery.find('.competition-gallery-item .competition-gallery-item__large.new');

		let closeGalleryTimeline = new TimelineMax({
			onComplete() {
				parallax.enable();
				$gallery.find('.competition-gallery-item').css('z-index', '1');

				$gallery.find('.competition-gallery-item .competition-gallery-item__large.new').removeClass('new');
				$gallery.find('.competition-gallery-item .competition-gallery-item__large.old').removeClass('old');

				$morephoto.fadeIn();
			},
			ease: Linear.easeNone,
		});

		closeGalleryTimeline
			.set($el, {
				// zIndex: '',
				autoAlpha: 1,
				scale: 1,
			})
			.to($el, 0.5, {
				autoAlpha: 0,
				scale: 0,
				ease: Power0.easeNone,
			});

		history.pushState(null, '', location.pathname);

		let image = `${location.pathname}/local/templates/main/images/share-contest.png`;

		image = image.replace('//', '/');
		image = location.origin + image;

		Share._metaUpdateByPageData({
			url: location.href,
			title: 'От Владивостока до Калининграда – Россия без границ',
			description: 'В совместном спецпроекте Samsung и РБК одиннадцать героев со всей России хотят доказать всем, что границы существуют только в наших головах.',
			image,
		});
	}

	// show photo gallery
	// eslint-disable-next-line no-inner-declarations
	function showGalleryPhoto() {
		let $photonew = $gallery.find('.competition-gallery-item .competition-gallery-item__large.new');
		let $photoold = $gallery.find('.competition-gallery-item .competition-gallery-item__large.old');

		parallax.disable();
		$gallery.find('.competition-gallery-item').css('z-index', '1');
		$gallery.find('.competition-gallery-item .competition-gallery-item__large.old').parent('.competition-gallery-item').css('z-index', '2');
		$gallery.find('.competition-gallery-item .competition-gallery-item__large.new').parent('.competition-gallery-item').css('z-index', '3');

		let showGalleryPhotoNewTimeline = new TimelineMax({
			onStart() {

			},
			onComplete() {
				$body.addClass('gallery-open');
			},
			ease: Linear.easeNone,
		});

		let hideGalleryPhotoOldTimeline = new TimelineMax({
			onStart() {

			},
			onComplete() {
				setTimeout(() => {
					$body.removeClass('gallery-lock');
				}, 250);
			},
			ease: Linear.easeNone,
		});

		showGalleryPhotoNewTimeline
			.set($photonew, {
				zIndex: 2,
				autoAlpha: 0,
				scale: 0,
				display: 'flex',
			})
			.to($photonew, 0.5, {
				autoAlpha: 1,
				scale: 1,
				ease: Power0.easeNone,
			});

		hideGalleryPhotoOldTimeline
			.set($photoold, {
				// zIndex: '',
				autoAlpha: 1,
				scale: 1,
			})
			.to($photoold, 0.5, {
				autoAlpha: 0,
				scale: 0,
				ease: Power0.easeNone,
				clearProps: 'all',
			})
			.set($photoold, {
				display: 'none',
			});

		// set photo url
		let id = $photonew.parent('.competition-gallery-item').data('id');

		queryPush({
			name: 'photo',
			id,
		});

		let meta = Share._metaElements();
		let image = location.pathname + $photonew.find('.competition-gallery-item__photo').attr('src');

		image = image.replace('//', '/');
		image = location.origin + image;

		Share._metaUpdateByPageData({
			url: `${location.origin}/social.php?id=${id}`,
			title: '',
			description: '',
			image,
		});

		document.title = '';
		meta.ogTitle.content = '';
		meta.twitterTitle.content = '';
		meta.description.content = '';
		meta.ogDescription.content = '';
	}

	// next photo
	// eslint-disable-next-line no-inner-declarations
	function showGalleryNextPhoto(next) {
		if (!$body.hasClass('gallery-lock')) {
			$body.addClass('gallery-lock');

			let $next = $gallery.find('.new').parents('.competition-gallery-item');

			$gallery.find('.old').removeClass('old');
			$next.find('.new').removeClass('new').addClass('old');

			if (next === 'next') {
				// next

				if ($next.next('.competition-gallery-item').length) {
					$next.next('.competition-gallery-item').find('.competition-gallery-item__large').addClass('new');
				} else {
					$gallery.find('.competition-gallery-item:eq(0)').find('.competition-gallery-item__large').addClass('new');
				}
			} else {
				// prev

				// eslint-disable-next-line no-lonely-if
				if ($next.prev('.competition-gallery-item').length) {
					$next.prev('.competition-gallery-item').find('.competition-gallery-item__large').addClass('new');
				} else {
					$gallery.find('.competition-gallery-item:eq(-1)').find('.competition-gallery-item__large').addClass('new');
				}
			}

			showGalleryPhoto();
		}
	}

	// LIKE BTN

	// eslint-disable-next-line func-names
	$gallery.on('click', '.competition-gallery-item__like--ico', function () {
		if (!lockicolike) {
			lockicolike = true;

			let id = $(this).parents('.competition-gallery-item').data('id');
			let $ico = $(this).parents('.competition-gallery-item').find('.competition-gallery-item__like--ico');
			let $count = $(this).parents('.competition-gallery-item').find('.competition-gallery-item__like--counter span');

			let icolikestate = $ico.hasClass('is-like') ? 'is-dislike' : 'is-like';

			$.ajax({
				type: 'GET',
				// backend
				url: '/like.php',
				dataType: 'json',
				// backend
				data: {
					photoid: id,
					event: icolikestate,
				},
				success(response) {
					// backend
					// response = likeIcoDATA; //###Debug
					// backend

					lockicolike = false;

					// backend
					if (response.success) {
						$count.text(response.counter);

						$ico.removeClass('is-like').removeClass('is-dislike').addClass(icolikestate);
					}
					// backend

					/*
					 $count.text(response.counter);

					 $ico.removeClass('is-like').removeClass('is-dislike').addClass(icolikestate);
					 */
				},
				error() {
					lockicolike = false;
				},
			});

			ga('send', 'event', 'competition', 'photo like', id);
		}

		return false;
	});

	// MORE GALLERY BTN
	// eslint-disable-next-line func-names
	$morephoto.on('click', function (e) {
		e.preventDefault();

		// eslint-disable-next-line no-undef
		if (clearoldphoto) {
			// eslint-disable-next-line no-undef
			clearoldphoto = false;
			oldphoto = [];
		} else {
			// eslint-disable-next-line func-names
			$gallery.find('.competition-gallery-item').each(function () {
				let id = $(this).data('id');

				oldphoto.push(id);
			});
		}

		photoid = undefined;
		createGallery($(this).attr('href'), oldphoto);

		return false;
	});

	// Router

	// http://localhost:3000/competition?name=photo&id=003
	let router = _.throttle(() => {
		let query = queryParse('object');

		switch (query.name) {
			case 'photo': {
				$('.button-tabs__btn[href="#tab-gallery"]').click();

				photoid = query.id;

				// show photo via id
				if (photoid) {
					if (!$body.hasClass('gallery-mobile') && $body.hasClass('gallery-ready')) {
						openGallery(query.id);
					}
				}

				break;
			}

			default: {
				break;
			}
		}

		if (query.name !== 'photo' && !window._formShown) {
			$(window).on('load', () => {
				ga('send', 'event', 'competition', 'form', 'show', {
					nonInteraction: true,
				});
				window._formShown = true;
			});
		}
	}, 1000, {
		trailing: false,
	});

	// Router init

	$window.on('popstate', router);

	router();
}

let setBlur = (ele, radius) => {
	$(ele).css({
		'-webkit-filter': `blur(${radius}px)`,
		'-moz-filter': `blur(${radius}px)`,
		'-ms-filter': `blur(${radius}px)`,
		'filter': `blur(${radius}px)`,
	});
};

let tweenBlur = (ele, startRadius, endRadius) => {
	$({
		blurRadius: startRadius,
	}).animate({
		blurRadius: endRadius,
	}, {
		duration: 500,
		easing: 'swing',
		step() {
			setBlur(ele, this.blurRadius);
		},
		complete() {
			setBlur(ele, endRadius);
		},
	});
};

